import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, AbstractControl } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";

@Component({
  selector: "app-editproductreview",
  templateUrl: "./editproductreview.component.html",
  styleUrls: ["./editproductreview.component.css"],
})
export class EditproductreviewComponent implements OnInit {
  @ViewChild("showvat") showvat: any;
  editMode: any;
  projectId: number = 0;
  inquiryId: number = 0;
  currencyName: any;
  selectedProjectId: any;
  chkRisk: boolean = false;
  chkRiskM: boolean = false;
  chkDev: boolean = false;
  chkPen: boolean = false;
  chkRet: boolean = false;
  IsPaAtAb: boolean = false;
  MTINum: string;
  Status: string;
  draft: any;
  soOption: any;
  clientSo: any;
  acknowledge: any;
  Modulepermi: any;
  projectEx: any;
  checkStatus: any;
  clientRc: any;
  soMargin: any;
  PayTerm: any;
  ProjectReq: any;
  ApprovedBy: any;
  disableDate() {
    return false;
  }
  userId: any;
  permission: any;
  userRId: any;
  id: any;
  optionsPro: string[] = [];
  showProjectArray: any = [];
  showContactArray: any = [];
  showDdValuesArray: any = [];
  showClient: any = [];
  quotationArray: any = [];
  ModeArray: any = [];
  paymentArray: any = [];
  salesArray: any = [];
  commercialArray: any = [];
  showIncoArray: any = [];
  managerArray: any = [];
  financeArray: any = [];
  generalArray: any = [];
  CreditArray: any = [];
  selectedInquiry: any = [];
  orderdata: any = [];
  Itemdata: any = [];
  Commercialdata: any = [];
  Guarnteedata: any = [];
  paymentTermdata: any = [];
  paymentListdata: any = [];
  SpecialProjectdata: any = [];
  subcontractdata: any = [];
  supplierdata: any = [];
  creditdata: any = [];
  warrantydata: any = [];
  registerForm: FormGroup;
  itemDescription: FormGroup;
  approvedBy: FormGroup;
  ProjectRequirement: FormGroup;
  commercialForm: FormGroup;
  PaymentTermInfo: FormGroup;
  searchword_Con: any = "";
  currency: string = "";
  pageSize: any = 99;
  currentPage: any = 0;
  isRender: boolean = false;
  inquiryProduct: any = [];
  totalProductSize: number;
  dollar: boolean = false;
  GrossValue: number = 0;
  TotalPrice: number = 0;
  TotalPriceQAR: number = 0;
  TotalPricewithVat: number = 0;
  TotalPricewithVatQAR: number = 0;
  previousPrice: number = 0;
  previousvat: number = 0;
  previousbalance: number = 0;
  groups: any = [];
  contractor: any = [];
  items: any = [];
  rowvalue: any = [];
  contractvalue: any = [];
  descript: any = [];
  vat: any = [];
  productId: any = [];
  brand: any = [];
  unit: any = [];
  showmodel: any = [];
  itemShow: any;
  CategoryShow: any;
  brandShow: any;
  errror: any = "";
  isCollapsed1: boolean = false;
  dataarray: any;
  client: any = [];
  clientId: any = [];
  verticalName: any = [];
  categoryName: any = [];
  AcknowledgeArray: any = [];
  ClientArray: any = [];
  ProjectExArray: any = [];
  selectedPaymentId: any;
  AdvanceArray: any = [];
  SelectArray: any = [];
  shownameArray: any = [];
  showContractArray: any = [];
  tvalue: any = [];
  orderId: number = 0;
  check: number = 0;
  VerticalId: any = [];
  vertical: any = [];
  category: any = [];
  clientName: any = [];
  ComInfo: boolean = false;
  activePanelIds: string[] = [];
  orderInfo: any = [];
  active: string;
  InquiryReceivedDate: Date;
  maxProjDate: Date;
  maxStartDate: Date;
  maxClientSoDate: Date;
  maxEqDeliverDate: Date;
  maxClientExDate: Date;
  projectValue: any = [];
  InquiryValue: any = [];
  selectedProject: any = [];
  selectedname: string[][] = [[]];
  selectedcontrat: string[][] = [[]];
  TotalQuotedSalesValue: number = 0;
  TotalReportedQuotedSalesValue: number = 0;
  TotalTaxAmount: number = 0;
  TotalTaxAmountQAR: number = 0;
  selectedStageId: any = "";
  totalQty: number = 0;
  reportedValue: number = 0; //handling % calculation from here
  baseValue: number = 0;
  baseValue1: number = 0;
  reportedValue1: number = 0;
  baseValue2: number = 0;
  reportedValue2: number = 0;
  baseValue3: number = 0;
  reportedValue3: number = 0;
  baseValue4: number = 0;
  reportedValue4: number = 0;
  baseValue5: number = 0;
  reportedValue5: number = 0;
  baseValue6: number = 0;
  reportedValue6: number = 0;
  baseValue7: number = 0;
  reportedValue7: number = 0;
  baseValue8: number = 0;
  reportedValue8: number = 0;
  baseValue9: number = 0;
  reportedValue9: number = 0;
  minSoAckDate: Date;
  maxSoAckDate: Date;
  isValidSubmit = false;
  DiscountPer: number = 0;
  TotalDiscountValue: number = 0;
  TotalDiscountQAR: number = 0;
  DiscountValue: number = 0;
  previousPersent: number = 0;
  showCurrencyArray: any = [];
  submitted1 = false;
  selectedCurrency = [];
  selectedCurrencyName: any;
  selectedCurrencyId: number = 0;
  selectedcSN: any;
  freightAmountQARValue: number = 0;
  freightCharges: number = 0;

  constructor(
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  advancePaidStatus1: boolean = false;
  advancePaidStatus4: boolean = false;
  advancePaidStatus5: boolean = false;
  advancePaidStatus7: boolean = false;
  advancePaidStatus9: boolean = false;
  advancePaidStatus10: boolean = false;
  advancePaidStatus11: boolean = false;
  advancePaidStatus12: boolean = false;
  advancePaidStatus13: boolean = false;

  dropdownSetting: any = {};
  dropdownSetting0: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  dropdownSetting6: any = {};
  dropdownSetting7: any = {};
  dropdownSetting8: any = {};
  dropdownSo: any = {};
  dropdownAc: any = {};
  dropdownCl: any = {};
  dropdownProjectEx: any = {};
  dropdownMode: any = {};
  dropdownAdvance: any = {};
  dropdownSelect: any = {};
  submitted: boolean = false;
  multiClick: boolean = false;
  showStageArray: any = [];
  CurrencySetting: any = {};

  createTicket(): FormGroup {
    return this.formBuilder.group({
      Supplier: [""],
      ExpectedPOAGRReleaseDate: [""],
      PORemark: [""],
      Status: ["1"],
      blankRow: [""],
    });
  }
  createContract(): FormGroup {
    return this.formBuilder.group({
      Supplier: [""],
      ExpectedPOAGRReleaseDate: [""],
      PORemark: [""],
      Status: ["1"],
      blankRow: [""],
    });
  }
  createOrder(): FormGroup {
    return this.formBuilder.group({
      CreditSplitPercentage: [""],
      CreditPerson: [""],
      Status: ["1"],
      blankRow: [""],
    });
  }
  get AdvanceAndLCId() {
    return this.commercialForm.get("AdvanceAndLCId") as FormControl;
  }
  get ALCReceived() {
    return this.commercialForm.get("ALCReceived") as FormControl;
  }
  get LCNumber() {
    return this.commercialForm.get("LCNumber") as FormControl;
  }
  get LCValue() {
    return this.commercialForm.get("LCValue") as FormControl;
  }
  get IssuedDate() {
    return this.commercialForm.get("IssuedDate") as FormControl;
  }
  get ExpiryDate() {
    return this.commercialForm.get("ExpiryDate") as FormControl;
  }
  get ExpectedDate() {
    return this.commercialForm.get("ExpectedDate") as FormControl;
  }
  get AdvanceAmt() {
    return this.commercialForm.get("AdvanceAmt") as FormControl;
  }
  get ReceivedDate() {
    return this.commercialForm.get("ReceivedDate") as FormControl;
  }
  get Stage() {
    return this.registerForm.get("Stage") as FormControl;
  }
  get Date() {
    return this.registerForm.get("Date") as FormControl;
  }
  get clientSoNumber() {
    return this.registerForm.get("clientSoNumber") as FormControl;
  }
  get clientSoDate() {
    return this.registerForm.get("clientSoDate") as FormControl;
  }
  get soReceiveDate() {
    return this.registerForm.get("soReceiveDate") as FormControl;
  }
  get clientExDate() {
    return this.registerForm.get("clientExDate") as FormControl;
  }
  get PayReceivedDate() {
    return this.PaymentTermInfo.get("ReceivedDate") as FormControl;
  }
  get PayExpectedDate() {
    return this.PaymentTermInfo.get("ExpectedDate") as FormControl;
  }

  get ConsultantApprovalRemark() {
    return this.registerForm.get("ConsultantApprovalRemark") as FormControl;
  }

  ngOnInit(): void {
    this.active = localStorage.getItem("active_id");
    let decid = this.route.snapshot.params["id"];
    decid = decid.toString().replace("Ar1t", "=").replace("FGH", "/").replace("THD", "+").replace("NST", "%");
    this.id = parseInt(this.UserService.decryptData(decid), 10);
    let UserId = localStorage.getItem("userId");
    this.userId = this.UserService.decryptData(UserId);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    let modulePermi = JSON.parse(localStorage.getItem("ModulePermission"));
    this.Modulepermi = this.UserService.decryptData(modulePermi);
    if (this.permission.OrderReview_Edit != 1 && this.userRId != 1) {
      if (this.Modulepermi.OrderReview == 1) {
        this.toastrService.error("You do not have permission");
        this.router.navigate(["/orderReview/orderreview"]);
      } else {
        this.toastrService.error("You do not have permission");
        this.router.navigate(["/profile"]);
      }
      return;
    }

    localStorage.setItem("editOid", decid);

    this.registerForm = this.formBuilder.group({
      OrderInfoId: [0],
      soOptions: ["", Validators.required],
      criticalShipment: ["1"],
      ProjectId: ["", Validators.required],
      inquiry: ["", Validators.required],
      clientName: [""],
      clientSoReceive: ["No"],
      remarkRcDate: ["", Validators.required],
      acknowledge: ["", Validators.required],
      projectExec: ["", Validators.required],
      eqDeliveryDate: ["", Validators.required],
      eqDeliveryRemark: ["", Validators.required],
      scopeWork: ["", Validators.required],
      clientContact: ["", Validators.required],
      Remark: ["", Validators.required],
      ConsultantApproval: [1, Validators.required]
    });

    this.registerForm.get("clientSoReceive").valueChanges.subscribe((value) => {
      if (value == "Yes") {
        this.registerForm.addControl(
          "clientSoNumber",
          this.formBuilder.control("", Validators.required)
        );
        this.registerForm.addControl(
          "clientSoDate",
          this.formBuilder.control("", Validators.required)
        );
        this.registerForm.addControl(
          "soReceiveDate",
          this.formBuilder.control("", Validators.required)
        );
        this.registerForm.removeControl("clientExDate");
      } else if (value == "No") {
        this.registerForm.addControl(
          "clientExDate",
          this.formBuilder.control("", Validators.required)
        );
        this.registerForm.removeControl("clientSoNumber");
        this.registerForm.removeControl("clientSoDate");
        this.registerForm.removeControl("soReceiveDate");
      } else if (value == "Not Applicable") {
        this.registerForm.removeControl("clientSoNumber");
        this.registerForm.removeControl("clientSoDate");
        this.registerForm.removeControl("soReceiveDate");
        this.registerForm.removeControl("clientExDate");
      }
      this.registerForm.updateValueAndValidity();
    });

    this.registerForm.get("ConsultantApproval").valueChanges.subscribe((value) => {
      if (value == 0) {
        this.registerForm.addControl(
          "ConsultantApprovalRemark",
          this.formBuilder.control("", Validators.required)
        );
      } else {
        this.registerForm.removeControl("ConsultantApprovalRemark");
      }
      this.registerForm.updateValueAndValidity();
    });

    this.itemDescription = this.formBuilder.group({
      Currency: ["", Validators.required],
      ReportedCurrencyRate: ["", [Validators.required, Validators.max(100000)]],
      CountryId: [""],
      OrderInfoId: this.id,
      ObjOrderItemDescription: this.formBuilder.array([]),
      DiscountValue: [""],
      TotalDiscountQAR: [""],
      TotalTaxAmount: [""],
      TotalTaxAmountQAR: [""],
      TotalPricewithVat: [""],
      TotalPricewithVatQAR: [""],
      TotalQuotedSalesValue: [""],
      TotalReportedQuotedSalesValue: [""],
      FreightAmountQAR: [0],
      FreightRemark: [""],
    });

    this.commercialForm = this.formBuilder.group({
      OrderInfoId: [""],
      IncoTerm: ["", Validators.required],
      ModeOfShipment: ["", Validators.required],
      SOContractBaseValue: [""],
      SOReportedValue: [""],
      AdvanceAndLC: ["false"],
      ClientPaymentCurrency: ["Base"],
      ProjectMargin: ["", Validators.required],
      ProjectStartDate: ["", Validators.required],
      ProjectCompletionDate: ["", Validators.required],
      CreditSplit: ["false"],

      ObjOrderCredit: this.formBuilder.array([]),
    });

    this.commercialForm.get("AdvanceAndLC").valueChanges.subscribe((value) => {
      if (value == true || value == "true") {
        this.commercialForm.addControl(
          "AdvanceAndLCId",
          this.formBuilder.control("", Validators.required)
        );
      } else {
        this.commercialForm.removeControl("AdvanceAndLCId");
        this.commercialForm.removeControl("ALCReceived");
        this.selectedAdvanceId = 0;
        this.selectedAdvance = "";
        this.commercialForm.removeControl("LCNumber");
        this.commercialForm.removeControl("LCValue");
        this.commercialForm.removeControl("IssuedDate");
        this.commercialForm.removeControl("ExpiryDate");
        this.commercialForm.removeControl("AdvanceAmt");
        this.commercialForm.removeControl("ReceivedDate");
        this.commercialForm.removeControl("ExpectedDate");
      }
      this.commercialForm.updateValueAndValidity();
    });

    this.ProjectRequirement = this.formBuilder.group({
      OrderInfoId: [""],
      SpecialRequirement: ["", Validators.required],
      RiskInvolved: ["false"],
      RiskRemark: [""],
      RiskMitigationPlan: [""],
      Penalties: ["false"],
      PenaltiesRemark: [""],
      DeviationContract: ["false"],
      DeviationContractRemark: [""],
      Retention: ["false"],
      RetentionRemark: [""],
      PBGGaurantee: ["false"],

      Advance: new FormGroup({
        GauranteePurpose: new FormControl("Advance"),
        GauranteePer: new FormControl(""),
        GauranteeType: new FormControl(""),
        Remark: new FormControl(""),
      }),
      AgainstSupply: new FormGroup({
        GauranteePurpose: new FormControl("Against Supply"),
        GauranteePer: new FormControl(""),
        GauranteeType: new FormControl(""),
        Remark: new FormControl(""),
      }),
      AgainstTC: new FormGroup({
        GauranteePurpose: new FormControl("Against T&C"),
        GauranteePer: new FormControl(""),
        GauranteeType: new FormControl(""),
        Remark: new FormControl(""),
      }),
      AgainstRetention: new FormGroup({
        GauranteePurpose: new FormControl("Against Retention"),
        GauranteePer: new FormControl(""),
        GauranteeType: new FormControl(""),
        Remark: new FormControl(""),
      }),
      AgainstDLP: new FormGroup({
        GauranteePurpose: new FormControl("Against DLP"),
        GauranteePer: new FormControl(""),
        GauranteeType: new FormControl(""),
        Remark: new FormControl(""),
      }),
    });

    const gauranteeGroups = [
      "Advance",
      "AgainstSupply",
      "AgainstTC",
      "AgainstRetention",
      "AgainstDLP",
    ];
    gauranteeGroups.forEach((group) => {
      const gauranteeGroups = this.ProjectRequirement.get(group);
      this.ProjectRequirement.get("PBGGaurantee").valueChanges.subscribe(
        (value) => {
          if (value === "false") {
            gauranteeGroups.get("GauranteePer").setValue(0);
            gauranteeGroups.get("GauranteeType").setValue(0);
            gauranteeGroups.get("Remark").setValue("");
          }
        }
      );
    });

    this.PaymentTermInfo = new FormGroup({
      OrderInfoId: new FormControl(""),
      ClientRegistration: new FormControl("", Validators.required),
      Warranty: new FormControl("false"),
      SupplierPO: new FormControl("false"),
      SubContractor: new FormControl("false"),

      Advance: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("Advance"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),
      AgainstDelivery: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("Against Delivery"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),
      AgainstInstallation: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("Against Installation"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),
      AgainstTestingandCommissioning: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("Against Testing and Commissioning"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),
      Againsthandingover: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("Against handing over"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),
      AfterDLP: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("After DLP"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),
      AgainsttoRepairService: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("Against to Repair / Service"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),
      Other1: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("Other 1"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),
      Other2: new FormGroup({
        PayRadioCheck: new FormControl(""),
        PaymentTermType: new FormControl("Other 2"),
        BaseValue: new FormControl(""),
        ReportedValue: new FormControl(""),
        ReportedValuePer: new FormControl("", [
          Validators.required,
          this.validatePercentage,
        ]),
        CreditDays: new FormControl("", Validators.required),
        ModeOfPayment: new FormControl("", Validators.required),
        PaymentRemark: new FormControl(""),
      }),

      FromDelivery: new FormGroup({
        WarrantyStartDate: new FormControl("From Delivery"),
        WholeUnitWarranty: new FormControl(""),
        PartsWarranty: new FormControl(""),
        Remark: new FormControl(""),
      }),
      FromStartupCommissioning: new FormGroup({
        WarrantyStartDate: new FormControl("From Start-up & Commissioning"),
        WholeUnitWarranty: new FormControl(""),
        PartsWarranty: new FormControl(""),
        Remark: new FormControl(""),
      }),
      FromHandingOver: new FormGroup({
        WarrantyStartDate: new FormControl("From Handing Over"),
        WholeUnitWarranty: new FormControl(""),
        PartsWarranty: new FormControl(""),
        Remark: new FormControl(""),
      }),
      FromInstallation: new FormGroup({
        WarrantyStartDate: new FormControl("From Installation"),
        WholeUnitWarranty: new FormControl(""),
        PartsWarranty: new FormControl(""),
        Remark: new FormControl(""),
      }),
      EitherDeliveryStartupCommissioning: new FormGroup({
        WarrantyStartDate: new FormControl(
          "Either Delivery / Start-up & Commissioning"
        ),
        WholeUnitWarranty: new FormControl(""),
        PartsWarranty: new FormControl(""),
        Remark: new FormControl(""),
      }),

      ObjOrderSupplier: this.formBuilder.array([]),

      ObjOrderSubContractor: this.formBuilder.array([]),
    });
    this.PaymentTermInfo.controls.Advance.updateValueAndValidity();

    // Subscribe to checkbox value changes for all groups
    const paymentGroups = [
      "Advance",
      "AgainstDelivery",
      "AgainstInstallation",
      "AgainstTestingandCommissioning",
      "Againsthandingover",
      "AfterDLP",
      "AgainsttoRepairService",
      "Other1",
      "Other2",
    ];
    paymentGroups.forEach((group) => {
      console.log(group,"group")
      
      const formGroup = this.PaymentTermInfo.get(group);
      formGroup.get("PayRadioCheck").valueChanges.subscribe((value) => {
        if (value === "false") {
          formGroup.get("BaseValue").setValue(0);
          formGroup.get("ReportedValue").setValue(0);
          formGroup.get("ReportedValuePer").setValue(0);
          formGroup.get("CreditDays").setValue(0);
          formGroup.get("ModeOfPayment").setValue(0);
          formGroup.get("PaymentRemark").setValue("");
          formGroup.get("ReportedValuePer").disable();
          formGroup.get("CreditDays").disable();
          formGroup.get("ModeOfPayment").disable();
          formGroup.get("PaymentRemark").disable();
        } else {
          formGroup.get("ReportedValuePer").enable();
          formGroup.get("CreditDays").enable();
          formGroup.get("ModeOfPayment").enable();
          formGroup.get("PaymentRemark").enable();
        }
      });
      formGroup.get("PayRadioCheck").setValue("false");
    });

    const warrantyGroups = [
      "FromDelivery",
      "FromStartupCommissioning",
      "FromHandingOver",
      "FromInstallation",
      "EitherDeliveryStartupCommissioning",
    ];
    warrantyGroups.forEach((group) => {
      const warrantyGroup = this.PaymentTermInfo.get(group);
      this.PaymentTermInfo.get("Warranty").valueChanges.subscribe((value) => {
        if (value === "false") {
          warrantyGroup.get("WholeUnitWarranty").setValue(0);
          warrantyGroup.get("PartsWarranty").setValue(0);
          warrantyGroup.get("Remark").setValue("");
        }
      });
    });

    this.approvedBy = this.formBuilder.group({
      OrderInfoId: [""],
      QuotationEngineer: ["", Validators.required],
      CommercialExecutive: ["", Validators.required],
      SalesEngineer: ["", Validators.required],
      SalesManager: [""],
      FinanceManager: ["", Validators.required],
      GeneralManager: ["", Validators.required],
    });

    this.dropdownSetting0 = {
      singleSelection: true,
      text: "Quotation Engineer",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting = {
      singleSelection: true,
      text: "Sales Engineer",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting1 = {
      singleSelection: true,
      text: "Sales Engineer",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting2 = {
      singleSelection: true,
      text: "Commercial Executive",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting3 = {
      singleSelection: true,
      text: "Sales Manager",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting4 = {
      singleSelection: true,
      text: "Finance Manager",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting5 = {
      singleSelection: true,
      text: "General Manager",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting6 = {
      singleSelection: false,
      text: "Contacts Name",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting7 = {
      singleSelection: true,
      text: "Inco Terms",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting8 = {
      singleSelection: true,
      text: "Stages",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSo = {
      singleSelection: true,
      text: "So Options",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownAc = {
      singleSelection: true,
      text: "So Acknowledge",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownCl = {
      singleSelection: true,
      text: "Client Registration",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownProjectEx = {
      singleSelection: true,
      text: "Project Execution",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownMode = {
      singleSelection: true,
      text: "Mode of Shipment",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownAdvance = {
      singleSelection: true,
      text: "Select",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownSelect = {
      singleSelection: true,
      text: "Select",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.CurrencySetting = {
      singleSelection: true,
      text: "Currency Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      searchBy: ["itemName"],
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.Quotation();
    this.GetInco();
    this.toValue();
    this.ddValues();
    this.getname();
    this.getstage();
    this.GetCurrency();

    let data = {
      OrderInfoId: this.id,
      Mode: "Edit",
    };
    this.spinner.show();
    this.UserService.GetOrderReviewDetailById(data).subscribe(
      (res) => {
        if (res["result"] == "Success") {
          this.spinner.hide();
          this.orderdata = res["OrderInformation"];
          this.Itemdata = res["ItemDescription"];
          this.Commercialdata = res["CommercialInformation"];
          this.Guarnteedata = res["GauranteeList"];
          this.paymentTermdata = res["PaymentTermInformation"];
          this.paymentListdata = res["PaymentTermList"];
          this.SpecialProjectdata = res["SpecialProjectRequirement"];
          this.subcontractdata = res["SubContractorList"];
          this.supplierdata = res["SupplierList"];
          this.warrantydata = res["WarrantyList"];
          this.creditdata = res["CreditSplitList"];

          this.freightCharges = res["OrderInformation"]["FreightAmount"];
          this.freightAmountQARValue = res["OrderInformation"]["FreightAmountQAR"];
          this.itemDescription.get('FreightAmountQAR').setValue(this.freightAmountQARValue.toFixed(2));
          if (this.itemDescription.get('FreightRemark').value == null) {
            this.itemDescription.get('FreightRemark').setValue("");
          }
          else {
            this.itemDescription.get('FreightRemark').setValue(res["OrderInformation"]["FreightRemark"]);
          }

          this.ComInfo = res["OrderInformation"]["IsComInfo"];
          this.PayTerm = res["OrderInformation"]["IsPayTerms"];
          this.ProjectReq = res["OrderInformation"]["IsSPR"];
          this.ApprovedBy = res["OrderInformation"]["IsPaAtAb"];
          this.draft = res["OrderInformation"]["CurrentStageName"];
          this.soOption = res["OrderInformation"]["SOOptionName"];
          this.clientSo = res["OrderInformation"]["ClientSOAGR"];
          this.acknowledge = res["OrderInformation"]["SOAcknowledgementName"];
          this.projectEx = res["OrderInformation"]["ProjectExecutionName"];
          this.IsPaAtAb = res["OrderInformation"]["IsPaAtAb"];

          if (this.soOption == "Cash Only") {
            this.selectedClientRc = [{ id: 25, itemName: "Not Required" }];
            this.selectedClientRcName = "Not Required";
            this.selectedClientId = 25;
          }

          if (res?.['CommercialInformation']) {
            if (res["CommercialInformation"]["SOContractBaseValue"]) {
              this.baseValue =
                res["CommercialInformation"]["SOContractBaseValue"];
            } else {
              this.baseValue = null;
            }

            if (res["CommercialInformation"]["SOReportedValue"]) {
              this.reportedValue =
                res["CommercialInformation"]["SOReportedValue"];
            } else {
              this.reportedValue = null;
            }
          }

          this.baseValue1 = res["PaymentTermList"][0]["BaseValue"];
          this.reportedValue1 = res["PaymentTermList"][0]["ReportedValue"];
          this.baseValue2 = res["PaymentTermList"][1]["BaseValue"];
          this.reportedValue2 = res["PaymentTermList"][1]["ReportedValue"];
          this.baseValue3 = res["PaymentTermList"][2]["BaseValue"];
          this.reportedValue3 = res["PaymentTermList"][2]["ReportedValue"];
          this.baseValue4 = res["PaymentTermList"][3]["BaseValue"];
          this.reportedValue4 = res["PaymentTermList"][3]["ReportedValue"];
          this.baseValue5 = res["PaymentTermList"][4]["BaseValue"];
          this.reportedValue5 = res["PaymentTermList"][4]["ReportedValue"];
          this.baseValue6 = res["PaymentTermList"][5]["BaseValue"];
          this.reportedValue6 = res["PaymentTermList"][5]["ReportedValue"];
          this.baseValue7 = res["PaymentTermList"][6]["BaseValue"];
          this.reportedValue7 = res["PaymentTermList"][6]["ReportedValue"];
          this.baseValue8 = res["PaymentTermList"][7]["BaseValue"];
          this.reportedValue8 = res["PaymentTermList"][7]["ReportedValue"];
          this.baseValue9 = res["PaymentTermList"][8]["BaseValue"];
          this.reportedValue9 = res["PaymentTermList"][8]["ReportedValue"];

          this.VerticalId = res["OrderInformation"]["BusinessVerticalId"];
          this.vertical = res["OrderInformation"]["BusinessVerticalName"];
          this.category = res["OrderInformation"]["BusinessCategory"];
          this.clientName = res["OrderInformation"]["ClientName"];
          this.projectId = res["OrderInformation"]["ProjectId"];
          this.inquiryId = res["OrderInformation"]["InquiryId"];
          this.currency = res["OrderInformation"]["currencyName"];
          this.MTINum = res["OrderInformation"]["MTINumber"];
          this.Status = res["OrderInformation"]["StatusName"];

          this.selectedPayment = res["PaymentTermList"][0]["ModeOfPaymentId"];
          this.selectedPayment1 = res["PaymentTermList"][1]["ModeOfPaymentId"];
          this.selectedPayment2 = res["PaymentTermList"][2]["ModeOfPaymentId"];
          this.selectedPayment3 = res["PaymentTermList"][3]["ModeOfPaymentId"];
          this.selectedPayment4 = res["PaymentTermList"][4]["ModeOfPaymentId"];
          this.selectedPayment5 = res["PaymentTermList"][5]["ModeOfPaymentId"];
          this.selectedPayment6 = res["PaymentTermList"][6]["ModeOfPaymentId"];
          this.selectedPayment7 = res["PaymentTermList"][7]["ModeOfPaymentId"];
          this.selectedPayment8 = res["PaymentTermList"][8]["ModeOfPaymentId"];

          this.selectedguarntee = res["GauranteeList"][0]["GauranteeType"];
          this.selectedguarntee1 = res["GauranteeList"][1]["GauranteeType"];
          this.selectedguarntee2 = res["GauranteeList"][2]["GauranteeType"];
          this.selectedguarntee3 = res["GauranteeList"][3]["GauranteeType"];
          this.selectedguarntee4 = res["GauranteeList"][4]["GauranteeType"];

          this.InquiryReceivedDate = new Date(
            moment(
              res["OrderInformation"]["InquiryReceivedDate"],
              "DD-MM-YYYY"
            ).format("MM-DD-YYYY")
          );

          if (this.orderdata) {
            this.selectedSo = [
              {
                id: res["OrderInformation"]["SOOption"],
                itemName: res["OrderInformation"]["SOOptionName"],
              },
            ];
            this.selectedSo.forEach((element) => {
              this.selectedSoName = element["itemName"];
              this.selectedSoId = element["id"];
            });

            if (this.selectedSoId == 1 && this.paymentTermdata == null) {
              this.PaymentTermInfo.get("Advance.PayRadioCheck").setValue(
                "true"
              );
              this.PaymentTermInfo.get(
                "AgainstDelivery.PayRadioCheck"
              ).setValue("false");
              this.PaymentTermInfo.get(
                "AgainstInstallation.PayRadioCheck"
              ).setValue("false");
              this.PaymentTermInfo.get(
                "AgainstTestingandCommissioning.PayRadioCheck"
              ).setValue("false");
              this.PaymentTermInfo.get(
                "Againsthandingover.PayRadioCheck"
              ).setValue("false");
              this.PaymentTermInfo.get("AfterDLP.PayRadioCheck").setValue(
                "false"
              );
              this.PaymentTermInfo.get(
                "AgainsttoRepairService.PayRadioCheck"
              ).setValue("false");
              this.PaymentTermInfo.get("Other1.PayRadioCheck").setValue(
                "false"
              );
              this.PaymentTermInfo.get("Other2.PayRadioCheck").setValue(
                "false"
              );
              this.PaymentTermInfo.get("Advance.ReportedValuePer").setValue(
                100
              );
              this.calculatePercentage();
              this.selectedPayment = [{ id: 1002, itemName: "Cash" }];
              this.selectedPayment.forEach((element) => {
                this.selectedPaymentName = element["itemName"];
                this.selectedPaymentId = element["id"];
              });
              this.PaymentTermInfo.get("Advance.ModeOfPayment").setValue(
                this.selectedPaymentId
              );
              this.changeDetectorRef.detectChanges();
            }

            this.selectedProject = [
              {
                id: res["OrderInformation"]["ProjectId"],
                itemName:
                  res["OrderInformation"]["ProjectName"] +
                  " (" +
                  res["OrderInformation"]["ProjectNumber"] +
                  ")",
              },
            ];
            this.projectValue = this.selectedProject[0].itemName;

            this.selectedInquiry = [
              {
                id: res["OrderInformation"]["InquiryId"],
                itemName:
                  res["OrderInformation"]["InquiryName"] +
                  " (" +
                  res["OrderInformation"]["InquiryNumber"] +
                  ")",
              },
            ];
            this.InquiryValue = this.selectedInquiry[0].itemName;

            this.selectedProjectEx = [
              {
                id: res["OrderInformation"]["ProjectExecution"],
                itemName: res["OrderInformation"]["ProjectExecutionName"],
              },
            ];
            this.selectedProjectEx.forEach((element) => {
              this.selectedProjectExName = element["itemName"];
              this.selectedProjectExId = element["id"];
            });

            let myArrayid = res["ClientPointOfContact"];
            this.selectedcontact = [];
            myArrayid.forEach((element) => {
              this.selectedcontact.push({
                id: element.ClientContactId,
                itemName: element.ClientContactName,
              });
            });
            this.selectedcontact.forEach((element) => {
              this.selectedContact += element["itemName"] + ", ";
              this.selectedContactId += element["id"] + ", ";
            });

            this.selectedstage = [
              {
                id: res["OrderInformation"]["CurrentStage"],
                itemName: res["OrderInformation"]["CurrentStageName"],
              },
            ];
            this.selectedstage.forEach((element) => {
              this.selectedStage = element["itemName"];
              this.selectedStageId = element["id"];
            });

            if (this.MTINum != "" && this.MTINum != null) {
              this.registerForm.addControl(
                "Stage",
                this.formBuilder.control("", Validators.required)
              );
            } else {
              this.registerForm.removeControl("Stage");
            }
            this.registerForm.updateValueAndValidity();

            if (this.orderdata.ClientSOAGR) {
              this.registerForm
                .get("clientSoReceive")
                .valueChanges.subscribe((value) => {
                  if (value == "Yes") {
                    this.registerForm.addControl(
                      "clientSoNumber",
                      this.formBuilder.control("", Validators.required)
                    );
                    this.registerForm.addControl(
                      "clientSoDate",
                      this.formBuilder.control("", Validators.required)
                    );
                    this.registerForm.addControl(
                      "soReceiveDate",
                      this.formBuilder.control("", Validators.required)
                    );
                    this.registerForm.removeControl("clientExDate");
                  } else if (value == "No") {
                    this.registerForm.addControl(
                      "clientExDate",
                      this.formBuilder.control("", Validators.required)
                    );
                    this.registerForm.removeControl("clientSoNumber");
                    this.registerForm.removeControl("clientSoDate");
                    this.registerForm.removeControl("soReceiveDate");
                  } else if (value == "Not Applicable") {
                    this.registerForm.removeControl("clientSoNumber");
                    this.registerForm.removeControl("clientSoDate");
                    this.registerForm.removeControl("soReceiveDate");
                    this.registerForm.removeControl("clientExDate");
                  }
                  this.registerForm.updateValueAndValidity();
                });
            }

            this.selectedAc = [
              {
                id: res["OrderInformation"]["SOAcknowledgement"],
                itemName: res["OrderInformation"]["SOAcknowledgementName"],
              },
            ];
            this.selectedAc.forEach((element) => {
              this.selectedAcName = element["itemName"];
              this.selectedAcId = element["id"];
            });

            if (this.orderdata.SOAcknowledgementName) {
              if (this.selectedAcId == 4 || this.selectedAcId == 5) {
                this.registerForm.addControl(
                  "Date",
                  this.formBuilder.control("", Validators.required)
                );
              } else {
                this.registerForm.removeControl("Date");
              }
            }
            this.registerForm.updateValueAndValidity();

            let currentDate = new Date();
            let currentDate2 = new Date();
            if (this.selectedAcId == 4) {
              this.minSoAckDate = new Date(
                moment(
                  res["OrderInformation"]["ClientSODate"],
                  "DD-MM-YYYY"
                ).format("MM-DD-YYYY")
              );
              this.maxSoAckDate = currentDate;
            } else if (this.selectedAcId == 5) {
              this.minSoAckDate = currentDate;
              this.maxSoAckDate = new Date(
                currentDate2.setMonth(currentDate2.getMonth() + 1)
              );
            }

            if (res["OrderInformation"]["CountryId"]) {
              this.dollar = true;
              this.selectedCurrency = [
                {
                  id: res["OrderInformation"]["CountryId"],
                  itemName: res["OrderInformation"]["currencyName"],
                },
              ];
              this.selectedCurrency.forEach((element) => {
                this.selectedCurrencyName = element["itemName"];
                this.selectedCurrencyId = element["id"];
              });
            }

            this.itemDescription.patchValue({
              ReportedCurrencyRate:
                res["OrderInformation"]["ReportedCurrencyRate"],
            });

            this.registerForm.patchValue({
              criticalShipment: res["OrderInformation"]["CriticalShipment"] === "Yes" ? 1 : 0,
              clientSoReceive: res["OrderInformation"]["ClientSOAGR"],
              clientSoNumber: res["OrderInformation"]["ClientSONumber"],
              clientSoDate: res["OrderInformation"]["ClientSODate"],
              soReceiveDate: res["OrderInformation"]["SOReceivedDate"],
              clientExDate: res["OrderInformation"]["ClientSOExpDate"],
              remarkRcDate: res["OrderInformation"]["RemarksSOReceiveDate"],
              Date: res["OrderInformation"]["SOAcknowledgementdate"],
              eqDeliveryDate: res["OrderInformation"]["EquipmentDeliveryDate"],
              eqDeliveryRemark: res["OrderInformation"]["EquipmentDeliveryRemark"],
              scopeWork: res["OrderInformation"]["ScopeOfWork"],
              Remark: res["OrderInformation"]["Remark"],
              ConsultantApproval: res["OrderInformation"]["ConsultantApproval"]
            });
          }
          if (this.registerForm.value.ConsultantApproval == 0) {
            this.registerForm.patchValue({
              ConsultantApprovalRemark: res["OrderInformation"]["ConsultantApprovalRemark"]
            });
          }


          if (this.Itemdata) {
            let ObjOrderItemDescription = this.itemDescription.get(
              "ObjOrderItemDescription"
            ) as FormArray;
            for (var i in this.Itemdata) {
              this.groups[i] = res["ItemDescription"][i]["CategoryId"];

              this.descript[i] = res["ItemDescription"][i]["Description"];

              this.showmodel[i] = [];

              this.items[i] = res["ItemDescription"][i]["ProductId"];

              this.vat[i] = res["ItemDescription"][i]["VatRate"];

              this.productId[i] = res["ItemDescription"][i]["ProductId"];

              this.unit[i] = res["ItemDescription"][i]["UnitType"];

              this.itemShow = res["ItemDescription"][i]["Code"];
              this.CategoryShow =
                res["ItemDescription"][i]["BusinessCategoryName"];
              this.brandShow = res["ItemDescription"][i]["BrandName"];

              ObjOrderItemDescription.push(
                this.formBuilder.group({
                  InquiryProductId: [this.Itemdata[i]["InquiryProductId"]],
                  ProductId: [this.Itemdata[i]["ProductId"]],
                  BusinessVertical: this.Itemdata[i].BusinessVerticalName,
                  BusinessCategory: this.Itemdata[i].BusinessCategoryName,
                  ProductBrandName: this.Itemdata[i].BrandName,
                  Itemcode: this.Itemdata[i].Code,
                  Description: [this.Itemdata[i].Description],
                  InquiryQuantity: [this.Itemdata[i].InquiryQuantity],
                  UnitRate: [this.Itemdata[i].UnitRate],
                  OrderQuantity: [this.Itemdata[i].OrderQuantity],
                  BalanceQuantity: [this.Itemdata[i].BalanceQuantity],
                  PreviousQuantity: [this.Itemdata[i].PreviousQuantity],
                  UnitType: this.Itemdata[i].UnitType,
                  DiscountPer: [this.Itemdata[i].DiscountPer],
                  TotalDiscountValue: [this.Itemdata[i].DiscountValue],
                  TotalPrice: [this.Itemdata[i].TotalPrice],
                  TotalPriceQAR: [this.Itemdata[i].TotalPriceQAR],
                  VatRate: [this.Itemdata[i].VatRate],
                  VatValue: [this.Itemdata[i].VatValue],
                  TotalPriceWithVat: [this.Itemdata[i].TotalPriceWithVat],
                  TotalPriceQARWithVat: [this.Itemdata[i].TotalPriceQARWithVat],
                  INST: [this.Itemdata[i].INST],
                  TandC: [this.Itemdata[i].TandC],
                  HandingOver: [this.Itemdata[i].HandingOver],
                  Warranty: [this.Itemdata[i].Warranty],
                })
              );
              this.getPrice(i);
            }
            this.GetInquiryDetail(this.inquiryId);
            this.getContact(this.inquiryId);
            this.getClient(this.inquiryId);
            this.isRender = true;

            this.orderInfo = res["OrderInformation"]["OrderInfoId"];
          }

          if (this.Commercialdata) {
            this.selectedInco = [
              {
                id: res["CommercialInformation"]["IncoTerm"],
                itemName: res["CommercialInformation"]["Name"],
              },
            ];
            this.selectedInco.forEach((element) => {
              this.selectedIncoName = element["itemName"];
              this.selectedIncoId = element["id"];
            });

            this.selectedMode = [
              {
                id: res["CommercialInformation"]["ModeOfShipment"],
                itemName: res["CommercialInformation"]["ModeOfShipmentName"],
              },
            ];
            this.selectedMode.forEach((element) => {
              this.selectedModeName = element["itemName"];
              this.selectedModeId = element["id"];
            });

            this.selectedCredit = [
              {
                id: res["CommercialInformation"]["CreditPerson"],
                itemName: res["CommercialInformation"]["CreditPersonName"],
              },
            ];
            this.selectedCredit.forEach((element) => {
              this.selectedcredit = element["itemName"];
              this.selectedCreditId = element["id"];
            });

            if (this.Commercialdata.AdvanceAndLC) {
              this.commercialForm
                .get("AdvanceAndLC")
                .valueChanges.subscribe((value) => {
                  if (value) {
                    this.commercialForm.addControl(
                      "AdvanceAndLCId",
                      this.formBuilder.control("", Validators.required)
                    );
                  } else {
                    this.commercialForm.removeControl("AdvanceAndLCId");
                    this.commercialForm.removeControl("ALCReceived");
                    this.commercialForm.removeControl("LCNumber");
                    this.commercialForm.removeControl("LCValue");
                    this.commercialForm.removeControl("IssuedDate");
                    this.commercialForm.removeControl("ExpiryDate");
                    this.commercialForm.removeControl("AdvanceAmt");
                    this.commercialForm.removeControl("ReceivedDate");
                    this.commercialForm.removeControl("ExpectedDate");
                  }
                  this.commercialForm.updateValueAndValidity();
                });
            }

            this.selectedAdvance = [
              {
                id: res["CommercialInformation"]["AdvanceAndLCId"],
                itemName: res["CommercialInformation"]["AdvanceAndLCName"],
              },
            ];
            this.selectedAdvance.forEach((element) => {
              this.selectedAdvanceName = element["itemName"];
              this.selectedAdvanceId = element["id"];
            });

            if (this.Commercialdata.AdvanceAndLCId) {
              if (
                this.selectedAdvanceId == 15 ||
                this.selectedAdvanceId == 16 ||
                this.selectedAdvanceId == 17
              ) {
                this.commercialForm.addControl("ALCReceived", this.formBuilder.control("", Validators.required));
              } else {
                this.commercialForm.removeControl("AdvanceAndLCId");
                this.commercialForm.removeControl("ALCReceived");
                this.commercialForm.removeControl("LCNumber");
                this.commercialForm.removeControl("LCValue");
                this.commercialForm.removeControl("IssuedDate");
                this.commercialForm.removeControl("ExpiryDate");
                this.commercialForm.removeControl("AdvanceAmt");
                this.commercialForm.removeControl("ReceivedDate");
                this.commercialForm.removeControl("ExpectedDate");
              }
              this.commercialForm.updateValueAndValidity();
            }

            if (this.selectedAdvanceId == 17) {
              this.AlcOption = this.Select.filter(
                (item) => item.id > 26 && item.id < 30
              ).map((item) => ({
                id: item.id,
                itemName: item.itemName,
              }));
            } else if (
              this.selectedAdvanceId == 15 ||
              this.selectedAdvanceId == 16
            ) {
              this.AlcOption = this.Select.filter(
                (item) => item.id == 30 || item.id == 31
              ).map((item) => ({
                id: item.id,
                itemName: item.itemName,
              }));
            }

            this.selectedOption = [
              {
                id: res["CommercialInformation"]["ALCReceived"],
                itemName: res["CommercialInformation"]["ALCReceivedName"],
              },
            ];
            this.selectedOption.forEach((element) => {
              this.selectedOptionName = element["itemName"];
              this.selectedOptionId = element["id"];
            });

            if (this.Commercialdata.ALCReceived) {
              if (this.selectedAdvanceId == 15 && this.selectedOptionId == 30) {
                this.commercialForm.addControl(
                  "LCNumber",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "LCValue",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "IssuedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "ExpiryDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.removeControl("ExpectedDate");
              } else if (
                this.selectedAdvanceId == 15 &&
                this.selectedOptionId == 31
              ) {
                this.commercialForm.addControl(
                  "ExpectedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.removeControl("LCNumber");
                this.commercialForm.removeControl("LCValue");
                this.commercialForm.removeControl("IssuedDate");
                this.commercialForm.removeControl("ExpiryDate");
                this.commercialForm.removeControl("AdvanceAmt");
                this.commercialForm.removeControl("ReceivedDate");
              } else if (
                this.selectedAdvanceId == 16 &&
                this.selectedOptionId == 30
              ) {
                this.commercialForm.addControl(
                  "AdvanceAmt",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "ReceivedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.removeControl("LCNumber");
                this.commercialForm.removeControl("LCValue");
                this.commercialForm.removeControl("IssuedDate");
                this.commercialForm.removeControl("ExpiryDate");
                this.commercialForm.removeControl("ExpectedDate");
              } else if (
                this.selectedAdvanceId == 16 &&
                this.selectedOptionId == 31
              ) {
                this.commercialForm.addControl(
                  "ExpectedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.removeControl("LCNumber");
                this.commercialForm.removeControl("LCValue");
                this.commercialForm.removeControl("IssuedDate");
                this.commercialForm.removeControl("ExpiryDate");
                this.commercialForm.removeControl("AdvanceAmt");
                this.commercialForm.removeControl("ReceivedDate");
              } else if (
                this.selectedAdvanceId == 17 &&
                this.selectedOptionId == 27
              ) {
                this.commercialForm.addControl(
                  "LCNumber",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "LCValue",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "IssuedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "ExpiryDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "AdvanceAmt",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "ReceivedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.removeControl("ExpectedDate");
              } else if (
                this.selectedAdvanceId == 17 &&
                this.selectedOptionId == 29
              ) {
                this.commercialForm.addControl(
                  "ExpectedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.removeControl("LCNumber");
                this.commercialForm.removeControl("LCValue");
                this.commercialForm.removeControl("IssuedDate");
                this.commercialForm.removeControl("ExpiryDate");
                this.commercialForm.removeControl("AdvanceAmt");
                this.commercialForm.removeControl("ReceivedDate");
              } else if (
                this.selectedAdvanceId == 17 &&
                this.selectedOptionId == 28
              ) {
                this.commercialForm.addControl(
                  "AdvanceAmt",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "ReceivedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.addControl(
                  "ExpectedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.commercialForm.removeControl("LCNumber");
                this.commercialForm.removeControl("LCValue");
                this.commercialForm.removeControl("IssuedDate");
                this.commercialForm.removeControl("ExpiryDate");
              }
              this.commercialForm.updateValueAndValidity();
            }

            this.commercialForm.patchValue({
              SOContractBaseValue:
                res["CommercialInformation"]["SOContractBaseValue"],
              SOReportedValue: res["CommercialInformation"]["SOReportedValue"],
              AdvanceAndLC: res["CommercialInformation"]["AdvanceAndLC"],
              AdvanceAndLCId: res["CommercialInformation"]["AdvanceAndLCId"],
              ALCReceived: res["CommercialInformation"]["ALCReceived"],
              LCNumber: res["CommercialInformation"]["LCNumber"],
              LCValue: res["CommercialInformation"]["LCValue"],
              IssuedDate: res["CommercialInformation"]["IssuedDate"],
              ExpiryDate: res["CommercialInformation"]["ExpiryDate"],
              ExpectedDate: res["CommercialInformation"]["ExpectedDate"],
              AdvanceAmt: res["CommercialInformation"]["AdvanceAmt"],
              ReceivedDate: res["CommercialInformation"]["ReceivedDate"],
              ClientPaymentCurrency:
                res["CommercialInformation"]["ClientPaymentCurrency"],
              ProjectMargin: res["CommercialInformation"]["ProjectMargin"],
              ProjectStartDate:
                res["CommercialInformation"]["ProjectStartDate"],
              ProjectCompletionDate:
                res["CommercialInformation"]["ProjectCompletionDate"],
              CreditSplit: res["CommercialInformation"]["CreditSplit"],
              CreditSplitPercentage:
                res["CommercialInformation"]["CreditSplitPercentage"],
            });

            const creditList = res["CreditSplitList"];
            const cntrl = <FormArray>this.commercialForm.get("ObjOrderCredit");
            this.rowvalue[i] = 1;
            while (cntrl.length) {
              cntrl.removeAt(0);
            }
            for (const credit of creditList) {
              this.selectedCredit.push(credit["CreditPerson"]);
              cntrl.push(
                this.formBuilder.group({
                  CreditPerson: credit["CreditPerson"],
                  CreditSplitPercentage: [credit["CreditSplitPercentage"]],
                  Status: ["1"],
                })
              );
            }

            let CreditValue = this.commercialForm.value;
            if (CreditValue.CreditSplit) {
              this.creditMode("true");
            } else {
              this.creditMode("false");
            }
          }

          if (this.paymentTermdata && this.paymentListdata) {
            this.clientRc =
              res["PaymentTermInformation"]["ClientRegistrationName"];

            this.selectedClientRc = [
              {
                id: res["PaymentTermInformation"]["ClientRegistration"],
                itemName:
                  res["PaymentTermInformation"]["ClientRegistrationName"],
              },
            ];
            this.selectedClientRc.forEach((element) => {
              this.selectedClientRcName = element["itemName"];
              this.selectedClientId = element["id"];
            });

            if (this.paymentTermdata.ClientRegistration) {
              if (this.selectedClientId == 24) {
                this.PaymentTermInfo.addControl(
                  "ReceivedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.PaymentTermInfo.removeControl("ExpectedDate");
              } else if (this.selectedClientId == 26) {
                this.PaymentTermInfo.addControl(
                  "ExpectedDate",
                  this.formBuilder.control("", Validators.required)
                );
                this.PaymentTermInfo.removeControl("ReceivedDate");
              } else {
                this.PaymentTermInfo.removeControl("ReceivedDate");
                this.PaymentTermInfo.removeControl("ExpectedDate");
              }
            }
            this.PaymentTermInfo.updateValueAndValidity();

            this.PaymentTermInfo.patchValue({
              ClientRegistration:
                res["PaymentTermInformation"]["ClientRegistrationName"],
              ReceivedDate: res["PaymentTermInformation"]["ReceivedDate"],
              ExpectedDate: res["PaymentTermInformation"]["ExpectedDate"],
              Warranty: res["PaymentTermInformation"]["Warranty"],
              SupplierPO: res["PaymentTermInformation"]["SupplierPO"],
              SubContractor: res["PaymentTermInformation"]["SubContractor"],

              Advance: {
                PayRadioCheck: res["PaymentTermList"][0]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][0]["BaseValue"],
                ReportedValue: res["PaymentTermList"][0]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][0]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][0]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][0]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][0]["PaymentRemark"],
              },
              AgainstDelivery: {
                PayRadioCheck: res["PaymentTermList"][1]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][1]["BaseValue"],
                ReportedValue: res["PaymentTermList"][1]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][1]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][1]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][1]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][1]["PaymentRemark"],
              },
              AgainstInstallation: {
                PayRadioCheck: res["PaymentTermList"][2]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][2]["BaseValue"],
                ReportedValue: res["PaymentTermList"][2]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][2]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][2]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][2]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][2]["PaymentRemark"],
              },
              AgainstTestingandCommissioning: {
                PayRadioCheck: res["PaymentTermList"][3]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][3]["BaseValue"],
                ReportedValue: res["PaymentTermList"][3]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][3]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][3]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][3]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][3]["PaymentRemark"],
              },
              Againsthandingover: {
                PayRadioCheck: res["PaymentTermList"][4]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][4]["BaseValue"],
                ReportedValue: res["PaymentTermList"][4]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][4]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][4]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][4]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][4]["PaymentRemark"],
              },
              AfterDLP: {
                PayRadioCheck: res["PaymentTermList"][5]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][5]["BaseValue"],
                ReportedValue: res["PaymentTermList"][5]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][5]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][5]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][5]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][5]["PaymentRemark"],
              },
              AgainsttoRepairService: {
                PayRadioCheck: res["PaymentTermList"][6]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][6]["BaseValue"],
                ReportedValue: res["PaymentTermList"][6]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][6]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][6]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][6]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][6]["PaymentRemark"],
              },
              Other1: {
                PayRadioCheck: res["PaymentTermList"][7]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][7]["BaseValue"],
                ReportedValue: res["PaymentTermList"][7]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][7]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][7]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][7]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][7]["PaymentRemark"],
              },
              Other2: {
                PayRadioCheck: res["PaymentTermList"][8]["CheckBox"]
                  ? "true"
                  : "false",
                BaseValue: res["PaymentTermList"][8]["BaseValue"],
                ReportedValue: res["PaymentTermList"][8]["ReportedValue"],
                ReportedValuePer:
                  res["PaymentTermList"][8]["ReportedValuePercentage"],
                CreditDays: res["PaymentTermList"][8]["CreditDays"],
                ModeOfPayment: res["PaymentTermList"][8]["ModeOfPaymentName"],
                PaymentRemark: res["PaymentTermList"][8]["PaymentRemark"],
              },
              FromDelivery: {
                WholeUnitWarranty: res["WarrantyList"][0]["WholeUnitWarranty"],
                PartsWarranty: res["WarrantyList"][0]["PartsWarranty"],
                Remark: res["WarrantyList"][0]["Remark"],
              },
              FromStartupCommissioning: {
                WholeUnitWarranty: res["WarrantyList"][1]["WholeUnitWarranty"],
                PartsWarranty: res["WarrantyList"][1]["PartsWarranty"],
                Remark: res["WarrantyList"][1]["Remark"],
              },
              FromHandingOver: {
                WholeUnitWarranty: res["WarrantyList"][2]["WholeUnitWarranty"],
                PartsWarranty: res["WarrantyList"][2]["PartsWarranty"],
                Remark: res["WarrantyList"][2]["Remark"],
              },
              FromInstallation: {
                WholeUnitWarranty: res["WarrantyList"][3]["WholeUnitWarranty"],
                PartsWarranty: res["WarrantyList"][3]["PartsWarranty"],
                Remark: res["WarrantyList"][3]["Remark"],
              },
              EitherDeliveryStartupCommissioning: {
                WholeUnitWarranty: res["WarrantyList"][4]["WholeUnitWarranty"],
                PartsWarranty: res["WarrantyList"][4]["PartsWarranty"],
                Remark: res["WarrantyList"][4]["Remark"],
              },
            });

            let SupplierValue = this.PaymentTermInfo.value;
            if (SupplierValue.SupplierPO) {
              this.supplierMode("true");
            } else {
              this.supplierMode("false");
            }
            const supplierList = res["SupplierList"];
            const cntrl = <FormArray>(
              this.PaymentTermInfo.get("ObjOrderSupplier")
            );
            this.rowvalue[i] = 1;
            while (cntrl.length) {
              cntrl.removeAt(0);
            }
            for (const supplier of supplierList) {
              // this.selectedname.push(supplier["Supplier"]);
              cntrl.push(
                this.formBuilder.group({
                  Supplier: supplier["Supplier"],
                  ExpectedPOAGRReleaseDate:
                    supplier["ExpectedPOAGRReleaseDate"],
                  PORemark: supplier["PORemark"],
                  Status: ["1"],
                })
              );
            }

            let ContractorValue = this.PaymentTermInfo.value;
            if (ContractorValue.SubContractor) {
              this.contractMode("true");
            } else {
              this.contractMode("false");
            }
            const subContractorList = res["SubContractorList"];
            const cntrl1 = <FormArray>(
              this.PaymentTermInfo.get("ObjOrderSubContractor")
            );
            this.contractvalue[i] = 1;
            while (cntrl1.length) {
              cntrl1.removeAt(0);
            }
            for (const subcontractor of subContractorList) {

              // this.selectedcontrat.push(subcontractor["Supplier"]);
              cntrl1.push(
                this.formBuilder.group({
                  Supplier: subcontractor["Supplier"],
                  ExpectedPOAGRReleaseDate: subcontractor["ExpectedPOAGRReleaseDate"],
                  PORemark: subcontractor["PORemark"],
                  Status: ["1"],
                })
              );
            }

            let warrantyValue = this.PaymentTermInfo.value;
            if (warrantyValue.Warranty) {
              this.modo1("true");
            } else {
              this.modo1("false");
            }
          }

          if (this.SpecialProjectdata) {
            let RiskValue = this.ProjectRequirement.value;
            if (
              RiskValue.RiskInvolved === "true" ||
              RiskValue.RiskInvolved === true
            ) {
              this.modo9("true");
            } else {
              this.modo9("false");
            }

            let penValue = this.ProjectRequirement.value;
            if (penValue.Penalties === "true" || penValue.Penalties === true) {
              this.modo10("true");
            } else {
              this.modo10("false");
            }

            let DeviValue = this.ProjectRequirement.value;
            if (
              DeviValue.DeviationContract === "true" ||
              DeviValue.DeviationContract === true
            ) {
              this.modo11("true");
            } else {
              this.modo11("false");
            }

            let RentValue = this.ProjectRequirement.value;
            if (
              RentValue.Retention === "true" ||
              RentValue.Retention === true
            ) {
              this.modo12("true");
            } else {
              this.modo12("false");
            }

            let PGBValue = this.ProjectRequirement.value;
            if (
              PGBValue.PBGGaurantee === "true" ||
              PGBValue.PBGGaurantee === true
            ) {
              this.modo13("true");
            } else {
              this.modo13("false");
            }

            this.ProjectRequirement.patchValue({
              SpecialRequirement:
                res["SpecialProjectRequirement"]["SpecialRequirement"],
              RiskInvolved: res["SpecialProjectRequirement"]["RiskInvolved"]
                ? "true"
                : "false",
              RiskRemark: res["SpecialProjectRequirement"]["RiskRemark"],
              RiskMitigationPlan:
                res["SpecialProjectRequirement"]["RiskMitigationPlan"],
              Penalties: res["SpecialProjectRequirement"]["Penalties"]
                ? "true"
                : "false",
              PenaltiesRemark:
                res["SpecialProjectRequirement"]["PenaltiesRemark"],
              DeviationContract: res["SpecialProjectRequirement"][
                "DeviationContract"
              ]
                ? "true"
                : "false",
              DeviationContractRemark:
                res["SpecialProjectRequirement"]["DeviationContractRemark"],
              Retention: res["SpecialProjectRequirement"]["Retention"]
                ? "true"
                : "false",
              RetentionRemark:
                res["SpecialProjectRequirement"]["RetentionRemark"],
              PBGGaurantee: res["SpecialProjectRequirement"]["PBGGaurantee"]
                ? "true"
                : "false",

              Advance: {
                GauranteePer: res["GauranteeList"][0]["GauranteePercentage"],
                GauranteeType: res["GauranteeList"][0]["GauranteeTypeName"],
                Remark: res["GauranteeList"][0]["Remark"],
              },
              AgainstSupply: {
                GauranteePer: res["GauranteeList"][1]["GauranteePercentage"],
                GauranteeType: res["GauranteeList"][1]["GauranteeTypeName"],
                Remark: res["GauranteeList"][1]["Remark"],
              },
              AgainstTC: {
                GauranteePer: res["GauranteeList"][2]["GauranteePercentage"],
                GauranteeType: res["GauranteeList"][2]["GauranteeTypeName"],
                Remark: res["GauranteeList"][2]["Remark"],
              },
              AgainstRetention: {
                GauranteePer: res["GauranteeList"][3]["GauranteePercentage"],
                GauranteeType: res["GauranteeList"][3]["GauranteeTypeName"],
                Remark: res["GauranteeList"][3]["Remark"],
              },
              AgainstDLP: {
                GauranteePer: res["GauranteeList"][4]["GauranteePercentage"],
                GauranteeType: res["GauranteeList"][4]["GauranteeTypeName"],
                Remark: res["GauranteeList"][4]["Remark"],
              },
            });

            // Call the functions to update field visibility
            this.modo9(this.ProjectRequirement.value.RiskInvolved);
            this.modo10(this.ProjectRequirement.value.Penalties);
            this.modo11(this.ProjectRequirement.value.DeviationContract);
            this.modo12(this.ProjectRequirement.value.Retention);
            this.modo13(this.ProjectRequirement.value.PBGGaurantee);

            if (this.orderdata) {
              if (this.orderdata.QuotationEngineer != null) {
                this.selectedQuotation = [
                  {
                    id: res["OrderInformation"]["QuotationEngineer"],
                    itemName: res["OrderInformation"]["QuotationEngineerName"],
                  },
                ];
                this.selectedQuotation.forEach((element) => {
                  this.selectedEngineer = element["itemName"];
                  this.selectedQuotationId = element["id"];
                });
              }

              if (this.orderdata.CommercialExecutive != null) {
                this.selectedCommercial = [
                  {
                    id: res["OrderInformation"]["CommercialExecutive"],
                    itemName:
                      res["OrderInformation"]["CommercialExecutiveName"],
                  },
                ];
                this.selectedCommercial.forEach((element) => {
                  this.selectedcommercial = element["itemName"];
                  this.selectedCommercialId = element["id"];
                });
              }

              if (this.orderdata.SalesEngineer != null) {
                this.selectedSales = [
                  {
                    id: res["OrderInformation"]["SalesEngineer"],
                    itemName: res["OrderInformation"]["SalesEngineerName"],
                  },
                ];
                this.selectedSales.forEach((element) => {
                  this.selectedsales = element["itemName"];
                  this.selectedSalesId = element["id"];
                });
              }

              if (this.orderdata.SalesManager != null) {
                this.selectedManager = [
                  {
                    id: res["OrderInformation"]["SalesManager"],
                    itemName: res["OrderInformation"]["SalesManagerName"],
                  },
                ];
                this.selectedManager.forEach((element) => {
                  this.selectedmanager = element["itemName"];
                  this.selectedManagerId = element["id"];
                });
              }

              if (this.orderdata.FinanceManager != null) {
                this.selectedFinance = [
                  {
                    id: res["OrderInformation"]["FinanceManager"],
                    itemName: res["OrderInformation"]["FinanceManagerName"],
                  },
                ];
                this.selectedFinance.forEach((element) => {
                  this.selectedfinance = element["itemName"];
                  this.selectedFinanceId = element["id"];
                });
              }

              if (this.orderdata.GeneralManager != null) {
                this.selectedGeneral = [
                  {
                    id: res["OrderInformation"]["GeneralManager"],
                    itemName: res["OrderInformation"]["GeneralManagerName"],
                  },
                ];
                this.selectedGeneral.forEach((element) => {
                  this.selectedgeneral = element["itemName"];
                  this.selectedGeneralId = element["id"];
                });
              }

              this.spinner.hide();
            }
          }
          if (!this.IsPaAtAb) {
            let data1 = {};
            this.UserService.GetAllProject(data1).subscribe((res) => {
              if (res["result"] == "success") {
                this.showProjectArray = res;
                this.selectedSales = [];
                this.selectedQuotation = [];
                this.selectedQuotationId = 0;
                this.selectedSalesId = 0;
                for (const projectData of this.showProjectArray["Data"]) {
                  if (projectData["ProjectId"] == this.projectId) {
                    this.selectedSales.push({
                      id: projectData["SalesEngineer"],
                      itemName: projectData["SalesEngineerName"],
                    });

                    this.selectedQuotation.push({
                      id: projectData["QuotationEngineer"],
                      itemName: projectData["QuotationEngineerName"],
                    });

                    this.selectedQuotationId = projectData["QuotationEngineer"];
                    this.selectedSalesId = projectData["SalesEngineer"];
                  }
                }
              }
            });
          }
        } else if (res["result"] == "Failed") {
          this.toastrService.error(res["Msg"]);
          this.spinner.hide();
          this.router.navigate(["/profile"]);
        } else {
          this.toastrService.error(res["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastrService.error(err.Msg || err.Message);
        }
      }
    );
  }

  get f() {
    return this.registerForm.controls;
  }
  get i() {
    return this.itemDescription.controls;
  }
  get c() {
    return this.commercialForm.controls;
  }
  get p() {
    return this.PaymentTermInfo.controls;
  }

  get ObjOrderCredit1(): any {
    let cntrl = <FormArray>this.commercialForm.get("ObjOrderCredit");
    return cntrl.controls;
  }

  get ObjOrderSupplier1(): any {
    let cntrl = <FormArray>this.PaymentTermInfo.get("ObjOrderSupplier");
    return cntrl.controls;
  }

  get ObjOrderSubContractor1(): any {
    let contract = <FormArray>this.PaymentTermInfo.get("ObjOrderSubContractor");
    return contract.controls;
  }

  validatePercentage(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value;
    if (value !== null && (isNaN(value) || value < 0 || value > 100)) {
      return { invalidPercentage: true };
    }
    return null;
  }

  onModeOfPaymentChange(value: string) {
    if (value === "0") {
      this.PaymentTermInfo.get("Advance.ModeOfPayment").setValue(null);
    } else {
      this.PaymentTermInfo.get("Advance.ModeOfPayment").setValue(value);
    }
  }

  countryList: any = [];
  showCurrency: any = [];
  GetCurrency() {
    let data = {
      UserId: this.userId,
    };
    this.UserService.GetCurrencyList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showCurrencyArray = res;
        for (const currencyData of this.showCurrencyArray["Data"]) {
          this.showCurrency.push({
            id: currencyData["id"],
            itemName: `${currencyData["currency"]} (${currencyData["currency_name"]})`,
            cSN: currencyData["currency"],
          });
          this.countryList.push({
            id: currencyData["id"],
            itemName: currencyData["name"],
          });
        }
      } else {
        this.showCurrencyArray = [];
        this.countryList = [];
      }
    });
  }
  onCurrencySelect(item: any) {
    this.selectedCurrencyName = "";
    this.selectedCurrencyId = 0;
    this.selectedCurrency.forEach((element) => {
      this.selectedCurrencyName = element["itemName"];
      this.selectedCurrencyId = element["id"];
      this.selectedcSN = element["cSN"];
    });
    this.currency = this.selectedcSN;
    if (this.currency == "QAR") {
      this.registerForm.get("ReportedCurrencyRate").setValue(1);
    }
  }

  currencySave() {
    if (
      this.itemDescription.value.ReportedCurrencyRate != null &&
      this.itemDescription.value.Currency[0] != null
    ) {
      if (this.itemDescription.value.ReportedCurrencyRate <= 0) {
        this.toastrService.error("Value must be greater than 0");
      } else if (this.itemDescription.value.ReportedCurrencyRate > 100000) {
        this.toastrService.error(
          "Value must be less than or equal to 99999.99"
        );
      } else if (
        this.itemDescription.value.Currency[0]["itemName"] == "QAR (Qatar)" &&
        this.itemDescription.value.ReportedCurrencyRate != 1
      ) {
        this.toastrService.error("Value should be 1,if currency is QAR");
      } else {
        this.dollar = true;
        this.currency = this.itemDescription.value.Currency[0]["itemName"];
        this.submitted1 = true;
        let data = {
          OrderInfoId: this.id,
          CountryId: this.itemDescription.value.Currency[0]["id"],
          ReportedCurrencyRate: this.itemDescription.value.ReportedCurrencyRate,
        };
        this.spinner.show();
        this.UserService.UpdateOrderCurrencyRate(data).subscribe((res) => {
          if (res["result"] == "success") {
            if (!this.dollar) {
            }
            this.spinner.hide();
            this.toastrService.success(res["Msg"]);
          } else if (res["result"] == "Failed") {
            this.spinner.hide();
            this.toastrService.error(res["Msg"]);
          } else {
            this.spinner.hide();
            this.toastrService.error(res["Message"]);
          }
          this.submitted1 = false;
        });
      }
    } else {
      this.toastrService.error("Please Fill Currency Fields");
      this.submitted1 = true;
    }
  }

  currencyEdit() {
    this.dollar = false;
  }

  showStage: any = [];
  getstage() {
    let data = {
      OrderInfoId: this.id,
    };
    this.UserService.GetStageListForOrder(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showStageArray = res;
        this.showStage = [];
        for (const stageData of this.showStageArray["Data"]) {
          this.showStage.push({
            id: stageData["StageId"],
            itemName: stageData["StageName"],
          });
        }
      } else {
        this.showStageArray = [];
      }
    });
  }
  selectedstage: any = [];
  selectedStage: any;
  onStageSelect(item: any) {
    this.selectedStage = "";
    this.selectedStageId = "";
    this.selectedstage.forEach((element) => {
      this.selectedStage = element["itemName"];
      this.selectedStageId = element["id"];
    });
  }

  togglePanel(panelId: string) {
    if (this.check >= 1) {
      const index = this.activePanelIds.indexOf(panelId);
      if (index > -1) {
        this.activePanelIds.splice(index, 1); // Remove the panelId if it exists
      } else {
        this.activePanelIds.push(panelId); // Add the panelId if it doesn't exist
      }
    } else {
      this.toastrService.error("Please save the item description first");
    }
  }

  addCredit() {
    const creditSplitValue = this.commercialForm.get("CreditSplit").value;
    const objOrderCreditArray = this.commercialForm.get("ObjOrderCredit") as FormArray;
    console.log(objOrderCreditArray.getRawValue(), "objOrderCreditArray")
    if (!creditSplitValue) {
      while (objOrderCreditArray.length) {
        objOrderCreditArray.removeAt(0);
      }
    } else if (objOrderCreditArray.length <= 4) {
      const newRow = this.createOrder();
      const statusControl = newRow.get("Status");

      if (statusControl.value !== 3) {
        objOrderCreditArray.push(newRow);
      }
    } else {
      this.toastrService.error("Up to five credits can be added");
    }
  }


  addTicket() {
    const supplierPOValue = this.PaymentTermInfo.get("SupplierPO").value;
    const add = <FormArray>this.PaymentTermInfo.get("ObjOrderSupplier");
    if (!supplierPOValue) {
      while (add.length) {
        add.removeAt(0);
      }
    } else {
      if (add.length <= 2) {
        const newRow = this.createTicket();
        add.push(newRow);
      } else {
        this.toastrService.error("Up to three suppliers can be added");
      }
    }
  }

  addContract() {
    const subContractValue = this.PaymentTermInfo.get("SubContractor").value;
    const add = <FormArray>this.PaymentTermInfo.get("ObjOrderSubContractor");
    if (!subContractValue) {
      while (add.length) {
        add.removeAt(0);
      }
    } else {
      if (add.length <= 2) {
        const newRow = this.createContract();
        add.push(newRow);
      } else {
        this.toastrService.error("Up to three contractors can be added");
      }
    }
  }

  advancePaid1(status) {
    this.advancePaidStatus1 = status;
  }
  advancePaid9(status) {
    this.advancePaidStatus9 = status;
  }
  advancePaid10(status) {
    this.advancePaidStatus10 = status;
  }
  advancePaid11(status) {
    this.advancePaidStatus11 = status;
  }
  advancePaid12(status) {
    this.advancePaidStatus12 = status;
  }
  advancePaid13(status) {
    this.advancePaidStatus13 = status;
  }

  modo1(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus1 = true;
        break;
      case "false":
        this.advancePaidStatus1 = false;
        break;
    }
  }

  creditMode(value: any) {
    this.changeDetectorRef.detectChanges();
    this.advancePaidStatus5 = !this.advancePaidStatus5;
    let orderControls = this.commercialForm.get("ObjOrderCredit") as FormArray;
    if (value == "true") {
      if (this.creditdata == null || this.creditdata.length == 0) {
        this.advancePaidStatus5 = true;
        this.addCredit();
        orderControls.at(0).get("CreditSplitPercentage").setValue("");
        this.selectedCredit[0] = null;
      }
      for (let i = 0; i < this.ObjOrderCredit1.length; i++) {
        const orderControl = this.ObjOrderCredit1.at(i).get("CreditPerson");
        const percentageControl = this.ObjOrderCredit1.at(i).get(
          "CreditSplitPercentage"
        );
        orderControl.setValidators(Validators.required);
        percentageControl.setValidators(Validators.required);
        orderControl.updateValueAndValidity();
        percentageControl.updateValueAndValidity();
      }
    } else {
      this.creditdata = null;
      for (let i = 0; i < this.ObjOrderCredit1.length; i++) {
        const orderControl = this.ObjOrderCredit1.at(i).get("CreditPerson");
        const percentageControl = this.ObjOrderCredit1.at(i).get(
          "CreditSplitPercentage"
        );
        orderControl.clearValidators();
        percentageControl.clearValidators();
        let orderControls = this.commercialForm.get(
          "ObjOrderCredit"
        ) as FormArray;
        while (orderControls.length) {
          orderControls.removeAt(0);
        }
        orderControl.updateValueAndValidity();
        percentageControl.updateValueAndValidity();
      }
    }
  }

  supplierMode(value: any) {
    this.changeDetectorRef.detectChanges();
    this.advancePaidStatus4 = !this.advancePaidStatus4;
    let supplierControls = <FormArray>(
      this.PaymentTermInfo.get("ObjOrderSupplier")
    );
    if (value == "true") {
      if (this.supplierdata == null || this.supplierdata.length == 0) {
        this.advancePaidStatus4 = true;
        this.addTicket();
        this.selectedname[0] = null;
        supplierControls.at(0).get("ExpectedPOAGRReleaseDate").setValue("");
        supplierControls.at(0).get("PORemark").setValue("");
      }
      for (let i = 0; i < this.ObjOrderSupplier1.length; i++) {
        const supplierControl = this.ObjOrderSupplier1.at(i).get("Supplier");
        const dateControl = this.ObjOrderSupplier1.at(i).get(
          "ExpectedPOAGRReleaseDate"
        );
        supplierControl.setValidators(Validators.required);
        dateControl.setValidators(Validators.required);
        supplierControl.updateValueAndValidity();
        dateControl.updateValueAndValidity();
      }
    } else {
      this.supplierdata = null;
      for (let i = 0; i < this.ObjOrderSupplier1.length; i++) {
        const supplierControl = this.ObjOrderSupplier1.at(i).get("Supplier");
        const dateControl = this.ObjOrderSupplier1.at(i).get(
          "ExpectedPOAGRReleaseDate"
        );
        supplierControl.clearValidators();
        dateControl.clearValidators();
        let supplierControls = <FormArray>(
          this.PaymentTermInfo.get("ObjOrderSupplier")
        );
        while (supplierControls.length) {
          supplierControls.removeAt(0);
        }
        supplierControl.updateValueAndValidity();
        dateControl.updateValueAndValidity();
      }
    }
  }

  contractMode(value: any) {
    this.changeDetectorRef.detectChanges();
    this.advancePaidStatus7 = !this.advancePaidStatus7;
    let contractControls = <FormArray>(
      this.PaymentTermInfo.get("ObjOrderSubContractor")
    );
    if (value == "true") {
      if (this.subcontractdata == null || this.subcontractdata.length == 0) {
        this.advancePaidStatus7 = true;
        this.addContract();
        this.selectedcontrat[0] = null;
        contractControls.at(0).get("ExpectedPOAGRReleaseDate").setValue(null);
        contractControls.at(0).get("PORemark").setValue("");
      }
      for (let i = 0; i < this.ObjOrderSubContractor1.length; i++) {
        const contractControl =
          this.ObjOrderSubContractor1.at(i).get("Supplier");
        const contractDateControl = this.ObjOrderSubContractor1.at(i).get("ExpectedPOAGRReleaseDate");
        contractControl.setValidators(Validators.required);
        // contractDateControl.setValidators(Validators.required);
        contractControl.updateValueAndValidity();
        contractDateControl.updateValueAndValidity();
      }
    } else {
      this.subcontractdata = null;
      for (let i = 0; i < this.ObjOrderSubContractor1.length; i++) {
        const contractControl =
          this.ObjOrderSubContractor1.at(i).get("Supplier");
        const contractDateControl = this.ObjOrderSubContractor1.at(i).get(
          "ExpectedPOAGRReleaseDate"
        );
        contractControl.clearValidators();
        // contractDateControl.clearValidators();
        let contractControls = <FormArray>(
          this.PaymentTermInfo.get("ObjOrderSubContractor")
        );
        while (contractControls.length) {
          contractControls.removeAt(0);
        }
        contractControl.updateValueAndValidity();
        contractDateControl.updateValueAndValidity();
      }
    }
  }

  modo9(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus9 = true;
        break;
      case "false":
        this.advancePaidStatus9 = false;
        break;
    }
  }

  modo10(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus10 = true;
        break;
      case "false":
        this.advancePaidStatus10 = false;
        break;
    }
  }

  modo11(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus11 = true;
        break;
      case "false":
        this.advancePaidStatus11 = false;
        break;
    }
  }

  modo12(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus12 = true;
        break;
      case "false":
        this.advancePaidStatus12 = false;
        break;
    }
  }

  modo13(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus13 = true;
        break;
      case "false":
        this.advancePaidStatus13 = false;
        break;
    }
  }

  calculatePercentage() {
   
    let base =
      this.PaymentTermInfo.controls.Advance.get("ReportedValuePer").value;
    let base1 =
      this.PaymentTermInfo.controls.AgainstDelivery.get(
        "ReportedValuePer"
      ).value;
    let base2 =
      this.PaymentTermInfo.controls.AgainstInstallation.get(
        "ReportedValuePer"
      ).value;
    let base3 =
      this.PaymentTermInfo.controls.AgainstTestingandCommissioning.get(
        "ReportedValuePer"
      ).value;
    let base4 =
      this.PaymentTermInfo.controls.Againsthandingover.get(
        "ReportedValuePer"
      ).value;
    let base5 =
      this.PaymentTermInfo.controls.AfterDLP.get("ReportedValuePer").value;
    let base6 =
      this.PaymentTermInfo.controls.AgainsttoRepairService.get(
        "ReportedValuePer"
      ).value;
    let base7 =
      this.PaymentTermInfo.controls.Other1.get("ReportedValuePer").value;
    let base8 =
      this.PaymentTermInfo.controls.Other2.get("ReportedValuePer").value;

    if (base > 100) {
      this.PaymentTermInfo.get("Advance.ReportedValuePer").setValue(100);
      this.toastrService.error("Value can not be greater than 100.00");
    }
    if (base1 > 100) {
      this.PaymentTermInfo.get("AgainstDelivery.ReportedValuePer").setValue(
        100
      );
      this.toastrService.error("Value can not be greater than 100.00");
    }
    if (base2 > 100) {
      this.PaymentTermInfo.get("AgainstInstallation.ReportedValuePer").setValue(
        100
      );
      this.toastrService.error("Value can not be greater than 100.00");
    }
    if (base3 > 100) {
      this.PaymentTermInfo.get(
        "AgainstTestingandCommissioning.ReportedValuePer"
      ).setValue(100);
      this.toastrService.error("Value can not be greater than 100.00");
    }
    if (base4 > 100) {
      this.PaymentTermInfo.get("Againsthandingover.ReportedValuePer").setValue(
        100
      );
      this.toastrService.error("Value can not be greater than 100.00");
    }
    if (base5 > 100) {
      this.PaymentTermInfo.get("AfterDLP.ReportedValuePer").setValue(100);
      this.toastrService.error("Value can not be greater than 100.00");
    }
    if (base6 > 100) {
      this.PaymentTermInfo.get(
        "AgainsttoRepairService.ReportedValuePer"
      ).setValue(100);
      this.toastrService.error("Value can not be greater than 100.00");
    }
    if (base7 > 100) {
      this.PaymentTermInfo.get("Other1.ReportedValuePer").setValue(100);
      this.toastrService.error("Value can not be greater than 100.00");
    }
    if (base8 > 100) {
      this.PaymentTermInfo.get("Other2.ReportedValuePer").setValue(100);
      this.toastrService.error("Value can not be greater than 100.00");
    }

    this.baseValue1 = parseFloat(((this.baseValue * base) / 100).toFixed(2));
    this.reportedValue1 = parseFloat(
      ((this.reportedValue * base) / 100).toFixed(2)
    );

    console.log(this.baseValue1,this.reportedValue1,"222222222222")
    this.baseValue2 = parseFloat(((this.baseValue * base1) / 100).toFixed(2));
    this.reportedValue2 = parseFloat(
      ((this.reportedValue * base1) / 100).toFixed(2)
    );
    this.baseValue3 = parseFloat(((this.baseValue * base2) / 100).toFixed(2));
    this.reportedValue3 = parseFloat(
      ((this.reportedValue * base2) / 100).toFixed(2)
    );
    this.baseValue4 = parseFloat(((this.baseValue * base3) / 100).toFixed(2));
    this.reportedValue4 = parseFloat(
      ((this.reportedValue * base3) / 100).toFixed(2)
    );
    this.baseValue5 = parseFloat(((this.baseValue * base4) / 100).toFixed(2));
    this.reportedValue5 = parseFloat(
      ((this.reportedValue * base4) / 100).toFixed(2)
    );
    this.baseValue6 = parseFloat(((this.baseValue * base5) / 100).toFixed(2));
    this.reportedValue6 = parseFloat(
      ((this.reportedValue * base5) / 100).toFixed(2)
    );
    this.baseValue7 = parseFloat(((this.baseValue * base6) / 100).toFixed(2));
    this.reportedValue7 = parseFloat(
      ((this.reportedValue * base6) / 100).toFixed(2)
    );
    this.baseValue8 = parseFloat(((this.baseValue * base7) / 100).toFixed(2));
    this.reportedValue8 = parseFloat(
      ((this.reportedValue * base7) / 100).toFixed(2)
    );
    this.baseValue9 = parseFloat(((this.baseValue * base8) / 100).toFixed(2));
    this.reportedValue9 = parseFloat(
      ((this.reportedValue * base8) / 100).toFixed(2)
    );
  }

  onDeleteCredit(rowIndex) {
    let orderControls = <FormArray>this.c.ObjOrderCredit;
    let fillValue = <FormArray>orderControls.controls[rowIndex];
    if (fillValue.controls["blankRow"]?.value == "") {
      orderControls.removeAt(rowIndex);
    } else {
      this.rowvalue[rowIndex] = 3;
    }
  }

  onDeleteSupplier(rowIndex) {
    let supplierControls = <FormArray>this.p.ObjOrderSupplier;
    let fillValue = <FormArray>supplierControls.controls[rowIndex];
    if (supplierControls.length > 1) {
      if (fillValue.controls["blankRow"]?.value == "") {
        supplierControls.removeAt(rowIndex);
      } else {
        this.rowvalue[rowIndex] = 3;
      }
    }
    else {
      this.toastrService.error("Min 1 row should be there when Supplier PO is applicable");
    }
  }

  onDeleteSubContract(rowIndex) {
    let contractorControls = <FormArray>this.p.ObjOrderSubContractor;
    let fillValue = <FormArray>contractorControls.controls[rowIndex];
    if (contractorControls.length > 1) {
      if (fillValue.controls["blankRow"]?.value == "") {
        contractorControls.removeAt(rowIndex);
      } else {
        this.contractvalue[rowIndex] = 3;
      }
    }
    else {
      this.toastrService.error("Min 1 row should be there when Sub Contractor PO/AGR is applicable");
    }
  }

  GetInquiryDetail(id) {
    let data = {
      InquiryId: id,
    };
    this.spinner.show();
    this.UserService.GetInquiryDetailById(data).subscribe((res) => {
      if (res["result"] == "success") {
        if (!this.ComInfo) {
          this.commercialForm.patchValue({
            ProjectMargin: res["Data"]["SOMargin"],
          });
        }
      }
      this.spinner.hide();
    });
  }

  newFunc(event: any) {
    this.maxStartDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }
  newFunc1(event: any) {
    this.maxProjDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }
  newFunc2(event: any) {
    this.maxClientSoDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }
  newFunc3(event: any) {
    this.maxEqDeliverDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }
  newFunc4(event: any) {
    this.maxClientExDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }

  formatNumber(value: number, decimalPlaces: number): string {
    const roundedValue =
      Math.floor(value * Math.pow(10, decimalPlaces)) /
      Math.pow(10, decimalPlaces);
    const data = roundedValue.toFixed(decimalPlaces);
    return data;
  }

  getPrice(index: any) {
    let ReportedCurrency = this.itemDescription.get("ReportedCurrencyRate").value;
    let rows = this.itemDescription.get("ObjOrderItemDescription") as FormArray;
    let price = rows.value[index]?.UnitRate;
    if (price > 999999.99) {
      price = this.previousPrice;
    }
    let quantity = rows.value[index]?.InquiryQuantity;
    let orQuantity = Number(rows.value[index]?.OrderQuantity);
    let prevQuantity = Number(rows.value[index]?.PreviousQuantity);
    this.totalQty = orQuantity + prevQuantity;
    let TotalPrice = orQuantity * price;
    let Percent = rows.value[index]?.DiscountPer;
    if (Percent > 100) {
      Percent = this.previousPersent;
    }
    let Discount = Number(((TotalPrice * Percent) / 100).toFixed(3));
    let checkDis = Math.floor(Discount * 100) / 100;
    let TP = TotalPrice - checkDis;
    if ((TP * 100) % 1 !== 0) {
      TP = Number(TP.toFixed(2));
    }
    let TPQAR = TP * ReportedCurrency;
    let TotalPriceQAR = Math.floor(TPQAR * 100) / 100;
    let vat = rows.value[index]?.VatRate;
    if (vat > 100) {
      vat = this.previousvat;
    }
    let taxAmount = (TP * vat) / 100;
    let tax_Amount = Math.floor(taxAmount * 100) / 100;
    let TotalPriceWithVat = TP + tax_Amount;
    if ((TotalPriceWithVat * 100) % 1 !== 0) {
      TotalPriceWithVat = Number(TotalPriceWithVat.toFixed(2));
    }
    let TotalPriceQARWithVat = TotalPriceWithVat * ReportedCurrency;
    let TTQARVAT = Math.floor(TotalPriceQARWithVat * 100) / 100;
    let balQuantity = Number(rows.value[index]?.BalanceQuantity);

    if (this.totalQty > quantity) {
      orQuantity = 0;
      rows.controls[index]?.get("OrderQuantity")?.setValue(orQuantity);
      this.toastrService.error("Value can not be greater than balance qty");
    } else if (orQuantity < 0) {
      orQuantity = 0;
      rows.controls[index]?.get("OrderQuantity")?.setValue(orQuantity);
    }

    balQuantity = quantity - this.totalQty;
    if (balQuantity < 0) {
      balQuantity = this.previousbalance;
    }

    rows.controls[index]?.patchValue({
      DiscountPer: Percent,
      BalanceQuantity: balQuantity,
      UnitRate: price,
      TotalDiscountValue: checkDis,
      TotalPrice: TP,
      TotalPriceQAR: TotalPriceQAR,
      VatRate: vat,
      VatValue: tax_Amount,
      TotalPriceWithVat: TotalPriceWithVat,
      TotalPriceQARWithVat: TTQARVAT,
    });

    this.totalsum();
    this.previousPrice = price;
    this.previousvat = vat;
    this.previousbalance = balQuantity;
    this.previousPersent = Percent;
  }

  getPrice1(index: any) {
    let ReportedCurrency = this.itemDescription.get(
      "ReportedCurrencyRate"
    ).value;
    let rows = this.itemDescription.get("ObjOrderItemDescription") as FormArray;
    let price = rows.value[index]?.UnitRate;
    let orQuantity = Number(rows.value[index]?.OrderQuantity);
    let prevQuantity = Number(rows.value[index]?.PreviousQuantity);
    this.totalQty = orQuantity + prevQuantity;
    let TotalPrice = orQuantity * price;
    let vat = rows.value[index]?.VatRate;
    let balQuantity = Number(rows.value[index]?.BalanceQuantity);
    let TotalDiscountValue = rows.value[index]?.TotalDiscountValue;

    // Ensure TotalDiscountValue is less than grossValue
    if (TotalDiscountValue > TotalPrice) {
      TotalDiscountValue = TotalPrice;
      this.toastrService.error("Value can not be greater than Gross Value");
      rows.controls[index]?.patchValue({
        TotalDiscountValue: TotalDiscountValue,
      });
    }

    let checkPer = (TotalDiscountValue / TotalPrice) * 100;
    let Percent = Math.floor(checkPer * 100) / 100;
    let TPWithVat = TotalPrice - TotalDiscountValue;
    let taxAmount = (TPWithVat * vat) / 100;
    let VatValue = Math.floor(taxAmount * 100) / 100;
    let TotalPriceWithVat = TPWithVat + VatValue;
    let Total_PQAR = TPWithVat * ReportedCurrency;
    let TotalPriceQAR = Math.floor(Total_PQAR * 100) / 100;
    let Total_PQARWVat = TotalPriceWithVat * ReportedCurrency;
    let TotalPriceQARWithVat = Math.floor(Total_PQARWVat * 100) / 100;

    rows.controls[index]?.patchValue({
      DiscountPer: Percent,
      BalanceQuantity: balQuantity,
      UnitRate: price,
      TotalPrice: TPWithVat,
      TotalPriceQAR: TotalPriceQAR,
      VatRate: vat,
      VatValue: VatValue,
      TotalPriceWithVat: TotalPriceWithVat,
      TotalPriceQARWithVat: TotalPriceQARWithVat,
    });

    this.totalsum();
    this.previousPrice = price;
    this.previousvat = vat;
    this.previousbalance = balQuantity;
  }

  totalsum() {
    this.freightAmountQARValue = this.itemDescription.controls.FreightAmountQAR.value;
    this.freightCharges = Math.floor((this.freightAmountQARValue / this.itemDescription.value.ReportedCurrencyRate) * 100) / 100;

    let rows = this.itemDescription.get("ObjOrderItemDescription") as FormArray;
    this.DiscountValue = 0;
    this.TotalQuotedSalesValue = 0;
    this.TotalReportedQuotedSalesValue = 0;
    this.TotalTaxAmount = 0;
    this.TotalPricewithVat = 0;
    this.TotalPricewithVatQAR = 0;
    for (const rowControl of rows.controls) {
      this.DiscountValue += Number(rowControl.value.TotalDiscountValue);
      this.TotalQuotedSalesValue += Number(rowControl.value.TotalPrice);
      this.TotalReportedQuotedSalesValue += Number(rowControl.value.TotalPriceQAR);
      this.TotalTaxAmount += Number(rowControl.value.VatValue);
      this.TotalPricewithVat += Number(rowControl.value.TotalPriceWithVat);
      this.TotalPricewithVatQAR += Number(rowControl.value.TotalPriceQARWithVat);
    }

    this.TotalPricewithVat = Number(this.TotalPricewithVat) + Number(this.freightCharges);
    this.TotalPricewithVatQAR = Number(this.TotalPricewithVatQAR) + Number(this.freightAmountQARValue);

    let TotalDiscountQAR = this.DiscountValue * this.itemDescription.value.ReportedCurrencyRate;
    let TotalDisQAR = Math.floor(TotalDiscountQAR * 100) / 100;
    let TotalTaxAmountQAR = this.TotalTaxAmount * this.itemDescription.value.ReportedCurrencyRate;
    let TotalVatQAR = Math.floor(TotalTaxAmountQAR * 100) / 100;

    this.TotalDiscountQAR = TotalDisQAR;
    this.TotalTaxAmountQAR = TotalVatQAR;

    let TotalReportedWoVat = Math.floor(this.TotalReportedQuotedSalesValue * 100) / 100;
    let TotalWithVatQar = Math.floor(this.TotalPricewithVatQAR * 100) / 100;

    this.itemDescription.patchValue({
      DiscountValue: this.DiscountValue.toFixed(2),
      TotalDiscountQAR: this.TotalDiscountQAR.toFixed(2),
      TotalQuotedSalesValue: this.TotalQuotedSalesValue.toFixed(2),
      TotalReportedQuotedSalesValue: TotalReportedWoVat,
      TotalTaxAmount: this.TotalTaxAmount.toFixed(2),
      TotalTaxAmountQAR: this.TotalTaxAmountQAR.toFixed(2),
      TotalPricewithVat: this.TotalPricewithVat.toFixed(2),
      TotalPricewithVatQAR: TotalWithVatQar,
    });
  }

  getValue(event: any) {
    let rows = this.itemDescription.get("ObjOrderItemDescription") as FormArray;
    for (const rowControl of rows.controls) {
      rowControl.patchValue({
        TotalPriceQAR: Number(
          rowControl.value.TotalPrice * event.target.value
        ).toFixed(2),
        TotalPriceQARWithVat: Number(
          rowControl.value.TotalPriceWithVat * event.target.value
        ).toFixed(2),
        TotalDiscountQAR: Number(
          rowControl.value.DiscountValue * event.target.value
        ).toFixed(2),
        TotalTaxAmountQAR: Number(
          rowControl.value.TotalTaxAmount * event.target.value
        ).toFixed(2),
      });
    }
  }

  modeP(event) {
    if (event.target.value > 100) {
      this.commercialForm.get("ProjectMargin").setValue(100);
      this.toastrService.error("Value can not be greater than 100.00");
    }
  }

  parseNUm(event) {
    if (event.target.value > 9999999999.99) {
      event.preventDefault();
      this.toastrService.error("Value can not be greater than 9999999999.99");
    }
  }

  singleWhiteSpaceAllowed(event) {
    const input = event.target.value;
    const formattedInput = input.replace(/[^0-9]/g, '').substring(0, 10);
    event.target.value = formattedInput;
  }

  keyPressNumeric(event) {
    const pattern = /[^0-9]/g;
    if (!pattern.test(event.target.value)) {
      event.preventDefault();
      return false;
    } else {
      event.target.value = event.target.value.replace(/[^0-9.]/g, "");
      event.preventDefault();
      return false;
    }
  }

  pasteNumbrother(event, i) {
    event.target.value = "paste";
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text");
    let newText = pastedText.replace(/[^0-9]/g, "");
    this.registerForm.patchValue({ UnitRate: newText });
  }

  pasteNum(event) {
    event.target.value = "paste";
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text");
    let newText = pastedText.replace(/[^0-9]/g, "");
    this.commercialForm.patchValue({ LCValue: newText });
  }

  pasteNumbr(event) {
    event.target.value = "paste";
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text");
    let newText = pastedText.replace(/[^0-9]/g, "");
    this.commercialForm.patchValue({ AdvanceAmt: newText });
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  getClient(id) {
    let data = {
      InquiryId: id,
    };
    this.UserService.GetInquiryOrderInfoById(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showClient = res["Data"];
        this.client = res["Data"]["ClientName"];
        this.clientId = res["Data"]["ClientId"];
        this.verticalName = res["Data"]["BusinessVerticalName"];
        this.categoryName = res["Data"]["BusinessCategory"];
      } else {
        this.showClient = [];
      }
    });
  }
  selectedClient: any = [];
  selectedClientName: any;
  selectedClinetId: any;
  onClientSelect(item: any) {
    this.selectedClientName = "";
    this.selectedClinetId = "";
    this.selectedClient.forEach((element) => {
      this.selectedClientName += element["itemName"];
      this.selectedClinetId += element["id"];
    });
  }

  showname: any = [];
  showncontrat: any = [];
  getname() {
    let data = {};
    this.UserService.GetAllCompanyForOrder(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.shownameArray = res;
        if (this.shownameArray["Data"]) {
          for (const dataItem of this.shownameArray["Data"]) {
            this.showname.push({
              id: dataItem["CompanyId"],
              itemName: `${dataItem["CompanyName"]} (${dataItem["CompanyType"]})`,
            });
            this.selectedname.push([""]);
          }
        }

        this.showContractArray = res;
        if (this.showContractArray["Data"]) {
          for (const dataItem of this.showContractArray["Data"]) {
            this.showncontrat.push({
              id: dataItem["CompanyId"],
              itemName: `${dataItem["CompanyName"]} (${dataItem["CompanyType"]})`,
            });
            this.selectedcontrat.push([""]);
          }
        }
      } else {
        this.shownameArray = [];
        this.showContractArray = [];
      }
    });
  }

  selectedName: any;
  selectedNameId: any;
  onSupplierSelect(item: any, rowIndex: number) {
    this.selectedName = "";
    this.selectedNameId = "";
    this.selectedname[rowIndex] = item.itemName;
    this.selectedname.forEach((element) => {
      this.selectedName += element["itemName"];
      this.selectedNameId += element["id"];
    });
  }

  selectedContractName: any;
  selectedContractId: any;
  onContractSelect(item: any, rowIndex1: number) {
    this.selectedContractName = "";
    this.selectedContractId = "";
    this.selectedcontrat[rowIndex1] = item.itemName;
    this.selectedcontrat.forEach((element) => {
      this.selectedContractName += element["itemName"];
      this.selectedContractId += element["id"];
    });
  }

  toValue() {
    let data = {};
    this.UserService.GetOrderReviewTOValues(data).subscribe((res) => { });
  }

  toggleColumnCheckboxes(event, columnName: string) {
    let ObjOrderItemDescription = this.itemDescription.get(
      "ObjOrderItemDescription"
    ) as FormArray;
    let isChecked = event.target.checked;
    for (let i = 0; i < ObjOrderItemDescription.length; i++) {
      const controlGroup = ObjOrderItemDescription.controls[i] as FormGroup;
      controlGroup.get(columnName).setValue(isChecked);
    }
  }

  SoOption: any = [];
  AcKnowledge: any = [];
  Client: any = [];
  ProjectEx: any = [];
  Mode: any = [];
  Advance: any = [];
  Select: any = [];
  AlcOption: any = [];
  guarntee: any = [];
  modePay: any = [];
  guarnteTyp: any = [];
  ddValues() {
    let data = {};
    this.UserService.GetOrderReviewDDValues(data).subscribe((res) => {
      if (res["result"] == "Success") {
        this.showDdValuesArray = res;
        for (const option of this.showDdValuesArray["SOOption"]) {
          this.SoOption.push({
            id: option["Id"],
            itemName: option["Name"],
          });
        }

        if (
          this.selectedSoName === "SO" ||
          this.selectedSoName === "SO Not Yet"
        ) {
          this.SoOption = this.SoOption.filter((option) => {
            return option.itemName !== "Cash Only";
          });
        } else {
          this.SoOption = this.SoOption;
        }
        this.AcknowledgeArray = res;
        for (const acknowledgement of this.AcknowledgeArray[
          "SOAcknowledgement"
        ]) {
          this.AcKnowledge.push({
            id: acknowledgement["Id"],
            itemName: acknowledgement["Name"],
          });
        }

        this.ClientArray = res;
        for (const option of this.ClientArray["ReceiveOption"]) {
          this.Client.push({
            id: option["Id"],
            itemName: option["Name"],
          });
        }

        this.ProjectExArray = res;
        for (const execution of this.ProjectExArray["ProjectExecution"]) {
          this.ProjectEx.push({
            id: execution["Id"],
            itemName: execution["Name"],
          });
        }

        this.ModeArray = res;
        for (const shipmentMode of this.ModeArray["ModeOfShipment"]) {
          this.Mode.push({
            id: shipmentMode["Id"],
            itemName: shipmentMode["Name"],
          });
        }

        this.paymentArray = res;
        if (this.paymentArray["ModeOfPayment"]) {
          for (const paymentMode of this.paymentArray["ModeOfPayment"]) {
            this.modePay.push({
              id: paymentMode["Id"],
              itemName: paymentMode["Name"],
            });
            this.selectedname.push([""]);
          }
        }

        this.AdvanceArray = res;
        for (const advanceItem of this.AdvanceArray["AdvanceAndLC"]) {
          this.Advance.push({
            id: advanceItem["Id"],
            itemName: advanceItem["Name"],
          });
        }

        this.SelectArray = res;
        for (const option of this.SelectArray["AdvanceAndLCOption"]) {
          this.Select.push({
            id: option["Id"],
            itemName: option["Name"],
          });
        }

        this.guarnteTyp = res["GaurantyType"];
      } else {
        this.showDdValuesArray = [];
        this.AcknowledgeArray = [];
        this.ClientArray = [];
        this.ProjectExArray = [];
        this.ModeArray = [];
        this.AdvanceArray = [];
        this.SelectArray = [];
      }
    });
  }

  selectedSo: any = [];
  selectedSoName: any;
  selectedSoId: any;
  onSoSelect(item: any) {
    this.selectedSoName = "";
    this.selectedSoId = "";
    this.selectedSo.forEach((element) => {
      if (element["id"] === 1) {
        this.selectedSoName = element["itemName"];
        this.selectedSoId = element["id"];
      }

      if (element["id"] === 2) {
        this.selectedSoName = element["itemName"];
        this.selectedSoId = element["id"];
      }

      if (element["id"] === 3) {
        this.selectedSoName = element["itemName"];
        this.selectedSoId = element["id"];
      }
    });

    if (this.selectedSoId === 1) {
      this.registerForm.get("clientSoReceive").setValue("Not Applicable");
    }

    if (this.selectedSoId === 2) {
      this.registerForm.get("clientSoReceive").setValue("Yes");
    }

    if (this.selectedSoId === 3) {
      this.registerForm.get("clientSoReceive").setValue("No");
    }
  }

  selectedAc: any = [];
  selectedAcName: any;
  selectedAcId: any;
  onAcknowledgeSelect(item: any) {
    this.registerForm.removeControl("Date");
    this.registerForm.updateValueAndValidity();
    this.selectedAcName = "";
    this.selectedAcId = "";
    this.selectedAc.forEach((element) => {
      this.selectedAcName += element["itemName"];
      this.selectedAcId += element["id"];
    });
    if (this.selectedAcId == 4 || this.selectedAcId == 5) {
      this.registerForm.addControl(
        "Date",
        this.formBuilder.control("", Validators.required)
      );
    } else {
      this.registerForm.removeControl("Date");
    }
    this.registerForm.updateValueAndValidity();

    let currentDate = new Date();
    let currentDate2 = new Date();
    if (this.selectedAcId == 4) {
      this.minSoAckDate = new Date(
        moment(this.registerForm.value.clientSoDate, "DD-MM-YYYY").format(
          "MM-DD-YYYY"
        )
      );
      this.maxSoAckDate = currentDate;
    } else if (this.selectedAcId == 5) {
      this.minSoAckDate = currentDate;
      this.maxSoAckDate = new Date(
        currentDate2.setMonth(currentDate2.getMonth() + 1)
      );
    }
  }

  selectedClientRc: any = [];
  selectedClientRcName: any;
  selectedClientId: any;
  onClientRcSelect(item: any) {
    this.PaymentTermInfo.removeControl("ReceivedDate");
    this.PaymentTermInfo.removeControl("ExpectedDate");
    this.PaymentTermInfo.updateValueAndValidity();
    this.selectedClientRcName = "";
    this.selectedClientId = "";
    this.selectedClientRc.forEach((element) => {
      this.selectedClientRcName = element["itemName"];
      this.selectedClientId = element["id"];
    });
    if (this.selectedClientId == 24) {
      this.PaymentTermInfo.addControl(
        "ReceivedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.PaymentTermInfo.removeControl("ExpectedDate");
    } else if (this.selectedClientId == 26) {
      this.PaymentTermInfo.addControl(
        "ExpectedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.PaymentTermInfo.removeControl("ReceivedDate");
    } else {
      this.PaymentTermInfo.removeControl("ReceivedDate");
      this.PaymentTermInfo.removeControl("ExpectedDate");
    }
    this.PaymentTermInfo.updateValueAndValidity();
  }

  selectedProjectEx: any = [];
  selectedProjectExName: any;
  selectedProjectExId: any;
  onProjectExSelect(item: any) {
    this.selectedProjectExName = "";
    this.selectedProjectExId = "";
    this.selectedProjectEx.forEach((element) => {
      this.selectedProjectExName = element["itemName"];
      this.selectedProjectExId = element["id"];
    });
  }
  selectedAdvance: any = [];
  selectedAdvanceName: any;
  selectedAdvanceId: any;
  onAdvanceSelect(item: any) {
    this.commercialForm.removeControl("ALCReceived");
    this.commercialForm.removeControl("LCNumber");
    this.commercialForm.removeControl("LCValue");
    this.commercialForm.removeControl("IssuedDate");
    this.commercialForm.removeControl("ExpiryDate");
    this.commercialForm.removeControl("AdvanceAmt");
    this.commercialForm.removeControl("ReceivedDate");
    this.commercialForm.removeControl("ExpectedDate");
    this.commercialForm.updateValueAndValidity();
    this.selectedAdvanceName = "";
    this.selectedAdvanceId = "";
    this.selectedAdvance.forEach((element) => {
      this.selectedAdvanceName = element["itemName"];
      this.selectedAdvanceId = element["id"];
    });
    if (item.id == 15 || item.id == 16 || item.id == 17) {
      this.commercialForm.addControl(
        "ALCReceived",
        this.formBuilder.control("", Validators.required)
      );
    } else {
      this.commercialForm.removeControl("ALCReceived");
      this.commercialForm.removeControl("LCNumber");
      this.commercialForm.removeControl("LCValue");
      this.commercialForm.removeControl("IssuedDate");
      this.commercialForm.removeControl("ExpiryDate");
      this.commercialForm.removeControl("AdvanceAmt");
      this.commercialForm.removeControl("ReceivedDate");
      this.commercialForm.removeControl("ExpectedDate");
    }
    this.commercialForm.updateValueAndValidity();

    if (this.selectedAdvanceId == 17) {
      this.AlcOption = this.Select.filter(
        (item) => item.id > 26 && item.id < 30
      ).map((item) => ({
        id: item.id,
        itemName: item.itemName,
      }));
    } else if (this.selectedAdvanceId == 15 || this.selectedAdvanceId == 16) {
      this.AlcOption = this.Select.filter(
        (item) => item.id == 30 || item.id == 31
      ).map((item) => ({
        id: item.id,
        itemName: item.itemName,
      }));
    }
  }

  selectedOption: any = [];
  selectedOptionName: any;
  selectedOptionId: any;
  onOptionSelect(item: any) {
    this.selectedOptionName = "";
    this.selectedOptionId = "";
    this.selectedOption.forEach((element) => {
      this.selectedOptionName = element["itemName"];
      this.selectedOptionId = element["id"];
    });
    if (this.selectedAdvanceId == 15 && this.selectedOptionId == 30) {
      this.commercialForm.addControl(
        "LCNumber",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "LCValue",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "IssuedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "ExpiryDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.removeControl("ExpectedDate");
    } else if (this.selectedAdvanceId == 15 && this.selectedOptionId == 31) {
      this.commercialForm.addControl(
        "ExpectedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.removeControl("LCNumber");
      this.commercialForm.removeControl("LCValue");
      this.commercialForm.removeControl("IssuedDate");
      this.commercialForm.removeControl("ExpiryDate");
      this.commercialForm.removeControl("AdvanceAmt");
      this.commercialForm.removeControl("ReceivedDate");
    } else if (this.selectedAdvanceId == 16 && this.selectedOptionId == 30) {
      this.commercialForm.addControl(
        "AdvanceAmt",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "ReceivedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.removeControl("LCNumber");
      this.commercialForm.removeControl("LCValue");
      this.commercialForm.removeControl("IssuedDate");
      this.commercialForm.removeControl("ExpiryDate");
      this.commercialForm.removeControl("ExpectedDate");
    } else if (this.selectedAdvanceId == 16 && this.selectedOptionId == 31) {
      this.commercialForm.addControl(
        "ExpectedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.removeControl("LCNumber");
      this.commercialForm.removeControl("LCValue");
      this.commercialForm.removeControl("IssuedDate");
      this.commercialForm.removeControl("ExpiryDate");
      this.commercialForm.removeControl("AdvanceAmt");
      this.commercialForm.removeControl("ReceivedDate");
    } else if (this.selectedAdvanceId == 17 && this.selectedOptionId == 27) {
      this.commercialForm.addControl(
        "LCNumber",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "LCValue",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "IssuedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "ExpiryDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "AdvanceAmt",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "ReceivedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.removeControl("ExpectedDate");
    } else if (this.selectedAdvanceId == 17 && this.selectedOptionId == 29) {
      this.commercialForm.addControl(
        "ExpectedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.removeControl("LCNumber");
      this.commercialForm.removeControl("LCValue");
      this.commercialForm.removeControl("IssuedDate");
      this.commercialForm.removeControl("ExpiryDate");
      this.commercialForm.removeControl("AdvanceAmt");
      this.commercialForm.removeControl("ReceivedDate");
    } else if (this.selectedAdvanceId == 17 && this.selectedOptionId == 28) {
      this.commercialForm.addControl(
        "AdvanceAmt",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "ReceivedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.addControl(
        "ExpectedDate",
        this.formBuilder.control("", Validators.required)
      );
      this.commercialForm.removeControl("LCNumber");
      this.commercialForm.removeControl("LCValue");
      this.commercialForm.removeControl("IssuedDate");
      this.commercialForm.removeControl("ExpiryDate");
    }
    this.commercialForm.updateValueAndValidity();
  }

  selectedguarntee: any = [];
  selectedguarnteeName: any;
  selectedguarnteeId: any;
  onguarnteeSelect(item: any) {
    this.selectedguarnteeName = "";
    this.selectedguarnteeId = "";
    this.selectedguarntee.forEach((element) => {
      this.selectedguarnteeName = element["itemName"];
      this.selectedguarnteeId = element["id"];
    });
  }
  selectedguarntee1: any = [];
  selectedguarnteeName1: any;
  selectedguarnteeId1: any;
  onguarnteeSelect1(item: any) {
    this.selectedguarnteeName1 = "";
    this.selectedguarnteeId1 = "";
    this.selectedguarntee1.forEach((element) => {
      this.selectedguarnteeName1 = element["itemName"];
      this.selectedguarnteeId1 = element["id"];
    });
  }
  selectedguarntee2: any = [];
  selectedguarnteeName2: any;
  selectedguarnteeId2: any;
  onguarnteeSelect2(item: any) {
    this.selectedguarnteeName2 = "";
    this.selectedguarnteeId2 = "";
    this.selectedguarntee2.forEach((element) => {
      this.selectedguarnteeName2 = element["itemName"];
      this.selectedguarnteeId2 = element["id"];
    });
  }
  selectedguarntee3: any = [];
  selectedguarnteeName3: any;
  selectedguarnteeId3: any;
  onguarnteeSelect3(item: any) {
    this.selectedguarnteeName3 = "";
    this.selectedguarnteeId3 = "";
    this.selectedguarntee3.forEach((element) => {
      this.selectedguarnteeName3 = element["itemName"];
      this.selectedguarnteeId3 = element["id"];
    });
  }
  selectedguarntee4: any = [];
  selectedguarnteeName4: any;
  selectedguarnteeId4: any;
  onguarnteeSelect4(item: any) {
    this.selectedguarnteeName4 = "";
    this.selectedguarnteeId4 = "";
    this.selectedguarntee4.forEach((element) => {
      this.selectedguarnteeName4 = element["itemName"];
      this.selectedguarnteeId4 = element["id"];
    });
  }
  selectedMode: any = [];
  selectedModeName: any;
  selectedModeId: any;
  onModeSelect(item: any) {
    this.selectedModeName = "";
    this.selectedModeId = "";
    this.selectedMode.forEach((element) => {
      this.selectedModeName = element["itemName"];
      this.selectedModeId = element["id"];
    });
  }
  selectedPayment: any[] = [];
  selectedPaymentName: any;
  onPaymentSelect(item: any) {
    this.selectedPaymentName = "";
    this.selectedPaymentId = "";
    this.selectedPayment.forEach((element) => {
      this.selectedPaymentName = element["itemName"];
      this.selectedPaymentId = element["id"];
    });
  }
  selectedPayment1: any = [];
  selectedPaymentName1: any = "";
  selectedPaymentId1: any = "";
  onPayment1Select(item: any) {
    this.selectedPaymentName1 = "";
    this.selectedPaymentId1 = "";
    this.selectedPayment1.forEach((element) => {
      this.selectedPaymentName1 = element["itemName"];
      this.selectedPaymentId1 = element["id"];
    });
  }
  selectedPayment2: any;
  selectedPaymentName2: any;
  selectedPaymentId2: any;
  onPayment2Select(item: any) {
    this.selectedPaymentName2 = "";
    this.selectedPaymentId2 = "";
    this.selectedPayment1.forEach((element) => {
      this.selectedPaymentName2 = element["itemName"];
      this.selectedPaymentId2 = element["id"];
    });
  }
  selectedPayment3: any = [];
  selectedPaymentName3: any;
  selectedPaymentId3: any;
  onPayment3Select(item: any) {
    this.selectedPaymentName3 = "";
    this.selectedPaymentId3 = "";
    this.selectedPayment3.forEach((element) => {
      this.selectedPaymentName3 = element["itemName"];
      this.selectedPaymentId3 = element["id"];
    });
  }
  selectedPayment4: any = [];
  selectedPaymentName4: any;
  selectedPaymentId4: any;
  onPayment4Select(item: any) {
    this.selectedPaymentName4 = "";
    this.selectedPaymentId4 = "";
    this.selectedPayment4.forEach((element) => {
      this.selectedPaymentName4 = element["itemName"];
      this.selectedPaymentId4 = element["id"];
    });
  }
  selectedPayment5: any = [];
  selectedPaymentName5: any;
  selectedPaymentId5: any;
  onPayment5Select(item: any) {
    this.selectedPaymentName5 = "";
    this.selectedPaymentId5 = "";
    this.selectedPayment1.forEach((element) => {
      this.selectedPaymentName5 = element["itemName"];
      this.selectedPaymentId5 = element["id"];
    });
  }
  selectedPayment6: any = [];
  selectedPaymentName6: any;
  selectedPaymentId6: any;
  onPayment6Select(item: any) {
    this.selectedPaymentName6 = "";
    this.selectedPaymentId6 = "";
    this.selectedPayment6.forEach((element) => {
      this.selectedPaymentName6 = element["itemName"];
      this.selectedPaymentId6 = element["id"];
    });
  }
  selectedPayment7: any = [];
  selectedPaymentName7: any;
  selectedPaymentId7: any;
  onPayment7Select(item: any) {
    this.selectedPaymentName7 = "";
    this.selectedPaymentId7 = "";
    this.selectedPayment7.forEach((element) => {
      this.selectedPaymentName7 = element["itemName"];
      this.selectedPaymentId7 = element["id"];
    });
  }
  selectedPayment8: any = [];
  selectedPaymentName8: any;
  selectedPaymentId8: any;
  onPayment8Select(item: any) {
    this.selectedPaymentName8 = "";
    this.selectedPaymentId8 = "";
    this.selectedPayment8.forEach((element) => {
      this.selectedPaymentName8 = element["itemName"];
      this.selectedPaymentId8 = element["id"];
    });
  }

  onItemSelect(item: any) { }
  OnItemDeSelect(item: any) { }

  tabclick1(id) {
    localStorage.setItem("active_id", "tab-selectbyid2");
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate([
      "/orderReview/editproductreview",
      encryptid,
      "orderattachment",
    ]);
  }

  showContact: any = [];
  getContact(id) {
    let data = {
      InquiryId: id,
    };
    this.UserService.GetClientContactByInquiryId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showContact = [];
        this.showContactArray = res;
        for (const contactData of this.showContactArray["Data"]) {
          this.showContact.push({
            id: contactData["ContactId"],
            itemName: `${contactData["ContactName"]} (${contactData["Email"]})`,
          });
        }
      } else {
        this.showContactArray = [];
      }
    });
  }
  selectedcontact: any = [];
  selectedContact: any;
  selectedContactId: any = "";
  onContactSelect(item: any) {
    this.selectedContact = "";
    this.selectedContactId = "";
    this.selectedcontact.forEach((element) => {
      this.selectedContact += element["itemName"] + ", ";
      this.selectedContactId += element["id"] + ", ";
    });
  }

  quotation: any = [];
  sales: any = [];
  commercial: any = [];
  manager: any = [];
  finance: any = [];
  general: any = [];
  credit: any = [];
  Quotation() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.quotationArray = res;
        for (const dataItem of this.quotationArray["Data"]) {
          this.quotation.push({
            id: dataItem["UserId"],
            itemName: `${dataItem["UserName"]}(${dataItem["EmailId"]})${dataItem["EmployeeId"]}`,
          });
        }

        this.salesArray = res;
        for (const dataItem of this.salesArray["Data"]) {
          this.sales.push({
            id: dataItem["UserId"],
            itemName: `${dataItem["UserName"]}(${dataItem["EmailId"]})${dataItem["EmployeeId"]}`,
          });
        }

        this.commercialArray = res;
        for (const dataItem of this.commercialArray["Data"]) {
          this.commercial.push({
            id: dataItem["UserId"],
            itemName: `${dataItem["UserName"]}(${dataItem["EmailId"]})${dataItem["EmployeeId"]}`,
          });
        }

        this.managerArray = res;
        for (const dataItem of this.managerArray["Data"]) {
          this.manager.push({
            id: dataItem["UserId"],
            itemName: `${dataItem["UserName"]}(${dataItem["EmailId"]})${dataItem["EmployeeId"]}`,
          });
        }

        this.financeArray = res;
        for (const dataItem of this.financeArray["Data"]) {
          this.finance.push({
            id: dataItem["UserId"],
            itemName: `${dataItem["UserName"]}(${dataItem["EmailId"]})${dataItem["EmployeeId"]}`,
          });
        }

        this.generalArray = res;
        for (const dataItem of this.generalArray["Data"]) {
          this.general.push({
            id: dataItem["UserId"],
            itemName: `${dataItem["UserName"]}(${dataItem["EmailId"]})${dataItem["EmployeeId"]}`,
          });
        }

        this.CreditArray = res;
        for (const dataItem of this.CreditArray["Data"]) {
          this.credit.push({
            id: dataItem["UserId"],
            itemName: `${dataItem["UserName"]} (${dataItem["EmployeeId"]})`,
          });
        }
      } else {
        this.quotationArray = [];
        this.salesArray = [];
        this.commercialArray = [];
        this.managerArray = [];
        this.financeArray = [];
        this.generalArray = [];
        this.CreditArray = [];
      }
    });
  }
  selectedQuotation: any = [];
  selectedEngineer: string = "";
  selectedQuotationId: any;
  onQuotationSelect(item: any) {
    this.selectedEngineer = "";
    this.selectedQuotationId = 0;
    this.selectedQuotation.forEach((element) => {
      this.selectedEngineer = element["itemName"];
      this.selectedQuotationId = element["id"];
    });
  }
  selectedSales: any = [];
  selectedsales: string = "";
  selectedSalesId: any;
  onSalesSelect(item: any) {
    this.selectedsales = "";
    this.selectedSalesId = 0;
    this.selectedSales.forEach((element) => {
      this.selectedsales = element["itemName"];
      this.selectedSalesId = element["id"];
    });
  }
  selectedCommercial: any = [];
  selectedcommercial: any;
  selectedCommercialId: any;
  onCommercialSelect(item: any) {
    this.selectedcommercial = "";
    this.selectedCommercialId = "";
    this.selectedCommercial.forEach((element) => {
      this.selectedcommercial = element["itemName"];
      this.selectedCommercialId = element["id"];
    });
  }
  selectedManager: any = [];
  selectedmanager: any;
  selectedManagerId: any;
  onManagerSelect(item: any) {
    this.selectedmanager = "";
    this.selectedManagerId = 0;
    this.selectedManager.forEach((element) => {
      this.selectedmanager = element["itemName"];
      this.selectedManagerId = element["id"];
    });
  }
  selectedFinance: any = [];
  selectedfinance: any;
  selectedFinanceId: any;
  onFinanceSelect(item: any) {
    this.selectedfinance = "";
    this.selectedFinanceId = "";
    this.selectedFinance.forEach((element) => {
      this.selectedfinance = element["itemName"];
      this.selectedFinanceId = element["id"];
    });
  }
  selectedGeneral: any = [];
  selectedgeneral: any;
  selectedGeneralId: any;
  onGeneralSelect(item: any) {
    this.selectedgeneral = "";
    this.selectedGeneralId = "";
    this.selectedGeneral.forEach((element) => {
      this.selectedgeneral = element["itemName"];
      this.selectedGeneralId = element["id"];
    });
  }
  selectedCredit: any = [];
  selectedcredit: any;
  selectedCreditId: any;
  onCreditSelect(item: any) {
    this.selectedcredit = "";
    this.selectedCreditId = "";
    this.selectedCredit.forEach((element) => {
      this.selectedcredit = element["itemName"];
      this.selectedCreditId = element["id"];
    });
  }

  showInco: any = [];
  GetInco() {
    let data = {};
    this.UserService.GetIncoTermList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showIncoArray = res;

        for (const item of this.showIncoArray["Data"]) {
          this.showInco.push({
            id: item["IncoTermId"],
            itemName: item["Name"],
          });
        }
      } else {
        this.showIncoArray = [];
      }
    });
  }
  selectedInco: any = [];
  selectedIncoName: any;
  selectedIncoId: any;
  onIncoSelect(item: any) {
    this.selectedIncoName = "";
    this.selectedIncoId = "";
    this.selectedInco.forEach((element) => {
      this.selectedIncoName = element["itemName"];
      this.selectedIncoId = element["id"];
    });
  }

  checkReq(event) {
    if (this.ProjectRequirement.value.RiskInvolved == "true") {
      if (this.ProjectRequirement.value.RiskRemark == "") {
        this.chkRisk = true;
        return;
      } else {
        this.chkRisk = false;
      }
      if (this.ProjectRequirement.value.RiskMitigationPlan == "") {
        this.chkRiskM = true;
        return;
      } else {
        this.chkRiskM = false;
      }
    } else {
      this.ProjectRequirement.value.RiskRemark = "";
      this.ProjectRequirement.value.RiskMitigationPlan = "";
      this.chkRisk = false;
      this.chkRiskM = false;
    }

    if (this.ProjectRequirement.value.Penalties == "true") {
      if (this.ProjectRequirement.value.PenaltiesRemark == "") {
        this.chkPen = true;
        return;
      } else {
        this.chkPen = false;
      }
    } else {
      this.ProjectRequirement.value.PenaltiesRemark = "";
      this.chkPen = false;
    }

    if (this.ProjectRequirement.value.DeviationContract == "true") {
      if (this.ProjectRequirement.value.DeviationContractRemark == "") {
        this.chkDev = true;
        return;
      } else {
        this.chkDev = false;
      }
    } else {
      this.ProjectRequirement.value.DeviationContractRemark = "";
      this.chkDev = false;
    }

    if (this.ProjectRequirement.value.Retention == "true") {
      if (this.ProjectRequirement.value.RetentionRemark == "") {
        this.chkRet = true;
        return;
      } else {
        this.chkRet = false;
      }
    } else {
      this.ProjectRequirement.value.RetentionRemark = "";
      this.chkRet = false;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (
      this.registerForm.value.clientSoDate == null ||
      this.registerForm.value.clientSoDate == ""
    ) {
      this.registerForm.value.clientSoDate = null;
    } else {
      this.registerForm.value.clientSoDate = moment(
        this.registerForm.value.clientSoDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.soReceiveDate == null ||
      this.registerForm.value.soReceiveDate == ""
    ) {
      this.registerForm.value.soReceiveDate = null;
    } else {
      this.registerForm.value.soReceiveDate = moment(
        this.registerForm.value.soReceiveDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.clientExDate == null ||
      this.registerForm.value.clientExDate == ""
    ) {
      this.registerForm.value.clientExDate = null;
    } else {
      this.registerForm.value.clientExDate = moment(
        this.registerForm.value.clientExDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.Date == null ||
      this.registerForm.value.Date == ""
    ) {
      this.registerForm.value.Date = null;
    } else {
      this.registerForm.value.Date = moment(
        this.registerForm.value.Date,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.eqDeliveryDate == null ||
      this.registerForm.value.eqDeliveryDate == ""
    ) {
      this.registerForm.value.eqDeliveryDate = null;
    } else {
      this.registerForm.value.eqDeliveryDate = moment(
        this.registerForm.value.eqDeliveryDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    let data = {
      OrderInfoId: this.id,
      Stage: this.selectedStageId,
      SOOption: this.selectedSoId,
      CriticalShipment: this.registerForm.value.criticalShipment,
      ProjectId: this.projectId,
      InquiryId: this.inquiryId,
      ClientId: this.clientId,
      ClientSOAGR: this.registerForm.value.clientSoReceive,
      ClientSONumber: this.registerForm.value.clientSoNumber,
      ClientSODate: this.registerForm.value.clientSoDate,
      ClientSOExpDate: this.registerForm.value.clientExDate,
      SOReceivedDate: this.registerForm.value.soReceiveDate,
      RemarksSOReceiveDate: this.registerForm.value.remarkRcDate,
      SOAcknowledgement: this.selectedAcId,
      SOAcknowledgementdate: this.registerForm.value.Date,
      ProjectExecution: this.selectedProjectExId,
      EquipmentDeliveryDate: this.registerForm.value.eqDeliveryDate,
      EquipmentDeliveryRemark: this.registerForm.value.eqDeliveryRemark,
      ScopeOfWork: this.registerForm.value.scopeWork,
      ClientContact: this.selectedContactId,
      Remark: this.registerForm.value.Remark,
      ConsultantApproval: this.registerForm.value.ConsultantApproval,
      ConsultantApprovalRemark: this.registerForm.value.ConsultantApprovalRemark
    };
    if (this.registerForm.valid) {
      this.multiClick = true;
      this.spinner.show();
      this.UserService.AddUpdateOrderInformation(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.orderId = res["Data"]["OrderInfoId"];
            this.check = 1;
            this.toastrService.success(res["Msg"]);
            let encryptid = this.UserService.encryptData(this.id);
            encryptid = encryptid.toString().replace("=", "Ar1t").replace("/", "FGH").replace("+", "THD");
            this.router.navigateByUrl("/RefreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigate(["/orderReview/editproductreview", encryptid]);
              });
          } else if (res["result"] == "Failed") {
            this.toastrService.error(res["Msg"]);
            this.spinner.hide();
          } else {
            this.toastrService.error(res["Msg"]);
          }
          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
          }
          this.multiClick = false;
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required fields");
      this.submitted = true;
      this.multiClick = false;
    }
  }

  onSubmit1() {
    if (this.dollar == false) {
      this.toastrService.error("Please save currency first");
      return;
    }
    this.submitted = true;
    const rows = this.itemDescription.get(
      "ObjOrderItemDescription"
    ) as FormArray;
    this.itemDescription.value.OrderInfoId = this.id;
    this.itemDescription.value.CountryId = this.selectedCurrencyId;
    this.itemDescription.value.ReportedCurrencyRate;
    const data = this.itemDescription.value;
    if (this.itemDescription.valid) {
      this.multiClick = true;
      let isOrderQtyValid = false; // initialize flag variable to false
      for (let i = 0; i < rows.length; i++) {
        const orderQuantityControl = rows.at(i).get("OrderQuantity");
        if (orderQuantityControl.value > 0) {
          // if order quantity is greater than zero
          isOrderQtyValid = true; // set flag variable to true
        }
        if (i === rows.length - 1 && !isOrderQtyValid) {
          // if it's the last row and no order quantity is greater than zero
          this.toastrService.error(
            "At least one item must have a minimum order QTY of 1"
          ); // show error message
          return;
        }
      }
      this.spinner.show();
      this.UserService.AddUpdateOrderItemDescription(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.check = 2;
            this.baseValue = res["Data"]["TotalPriceWithVat"];
            this.reportedValue = res["Data"]["TotalPriceQARWithVat"];
            this.errror = "";
            this.toastrService.success(res["Msg"]);
            this.calculatePercentage();
            let encryptid = this.UserService.encryptData(this.id);
            encryptid = encryptid
              .toString()
              .replace("=", "Ar1t")
              .replace("/", "FGH")
              .replace("+", "THD");
            this.router.navigate(["/orderReview/editproductreview", encryptid]);
          } else if (res["result"] == "Failed") {
            this.spinner.hide();

            if (res["error"] == "Tax Rate") {
              this.showvat.nativeElement.click();
              this.isCollapsed1 = true;
              this.dataarray = res["Data"];
            }
            this.toastrService.error(res["Msg"]);
          } else {
            this.toastrService.error(res["Msg"]);
            this.spinner.hide();
          }

          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
            this.multiClick = false;
          }
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required Fields");
      this.submitted = true;
    }
  }

  onSubmit2() {
    this.submitted = true;
    // Calculate the sum of ReportedValuePer
    let perCount = this.commercialForm.value.ObjOrderCredit.reduce(
      (sum, element) => {
        if (element.Status != 3) {
          return sum + Number(element.CreditSplitPercentage);
        }
      },
      0
    );
    if (perCount > 100) {
      this.toastrService.error("Total Credit Split % can not be more than 100");
      return;
    } else if (perCount < 100) {
      const creditSplit = this.commercialForm.value.CreditSplit;
      if (creditSplit === true || creditSplit === "true") {
        this.toastrService.error(
          "Total Credit Split % cannot be less than 100"
        );
        return;
      }
    }

    if (
      this.commercialForm.value.IssuedDate == null ||
      this.commercialForm.value.IssuedDate == ""
    ) {
      this.commercialForm.value.IssuedDate = null;
    } else {
      this.commercialForm.value.IssuedDate = moment(
        this.commercialForm.value.IssuedDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.commercialForm.value.ExpiryDate == null ||
      this.commercialForm.value.ExpiryDate == ""
    ) {
      this.commercialForm.value.ExpiryDate = null;
    } else {
      this.commercialForm.value.ExpiryDate = moment(
        this.commercialForm.value.ExpiryDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.commercialForm.value.ExpectedDate == null ||
      this.commercialForm.value.ExpectedDate == ""
    ) {
      this.commercialForm.value.ExpectedDate = null;
    } else {
      this.commercialForm.value.ExpectedDate = moment(
        this.commercialForm.value.ExpectedDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.commercialForm.value.ReceivedDate == null ||
      this.commercialForm.value.ReceivedDate == ""
    ) {
      this.commercialForm.value.ReceivedDate = null;
    } else {
      this.commercialForm.value.ReceivedDate = moment(
        this.commercialForm.value.ReceivedDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.commercialForm.value.ProjectStartDate == null ||
      this.commercialForm.value.ProjectStartDate == ""
    ) {
      this.commercialForm.value.ProjectStartDate = null;
    } else {
      this.commercialForm.value.ProjectStartDate = moment(
        this.commercialForm.value.ProjectStartDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.commercialForm.value.ProjectCompletionDate == null ||
      this.commercialForm.value.ProjectCompletionDate == ""
    ) {
      this.commercialForm.value.ProjectCompletionDate = null;
    } else {
      this.commercialForm.value.ProjectCompletionDate = moment(
        this.commercialForm.value.ProjectCompletionDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }

    let data = {
      OrderInfoId: this.id,
      IncoTerm: this.selectedIncoId,
      ModeOfShipment: this.selectedModeId,
      SOContractBaseValue: this.commercialForm.value.SOContractBaseValue,
      SOReportedValue: this.commercialForm.value.SOReportedValue,
      AdvanceAndLC: this.commercialForm.value.AdvanceAndLC,
      AdvanceAndLCId: this.selectedAdvanceId,
      ALCReceived: this.selectedOptionId,
      LCNumber: this.commercialForm.value.LCNumber,
      LCValue: this.commercialForm.value.LCValue,
      IssuedDate: this.commercialForm.value.IssuedDate,
      ExpiryDate: this.commercialForm.value.ExpiryDate,
      ExpectedDate: this.commercialForm.value.ExpectedDate,
      AdvanceAmt: this.commercialForm.value.AdvanceAmt,
      ReceivedDate: this.commercialForm.value.ReceivedDate,
      ClientPaymentCurrency: this.commercialForm.value.ClientPaymentCurrency,
      ProjectMargin: this.commercialForm.value.ProjectMargin,
      ProjectStartDate: this.commercialForm.value.ProjectStartDate,
      ProjectCompletionDate: this.commercialForm.value.ProjectCompletionDate,
      CreditSplit: this.commercialForm.value.CreditSplit,
      ObjCreditSplit: this.commercialForm.value.ObjOrderCredit,
    };
    if (this.commercialForm.valid) {
      this.multiClick = true;
      this.spinner.show();
      this.UserService.AddUpdateOrderCommercialInformation(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.check = 3;
            this.toastrService.success(res["Msg"]);
            let encryptid = this.UserService.encryptData(this.id);
            encryptid = encryptid
              .toString()
              .replace("=", "Ar1t")
              .replace("/", "FGH")
              .replace("+", "THD");
            this.router.navigate(["/orderReview/editproductreview", encryptid]);
          } else if (res["result"] == "Failed") {
            this.toastrService.error(res["Msg"]);
          } else {
            this.toastrService.error(res["Message"]);
          }
          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
          }
          this.multiClick = false;
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required fields");
      this.submitted = true;
      this.multiClick = false;
    }
  }

  onSubmit3() {
    this.submitted = true;
    let data = {
      OrderInfoId: this.id,
      QuotationEngineer: this.selectedQuotationId,
      CommercialExecutive: this.selectedCommercialId,
      SalesEngineer: this.selectedSalesId,
      SalesManager: this.selectedManagerId,
      FinanceManager: this.selectedFinanceId,
      GeneralManager: this.selectedGeneralId,
    };
    if (this.approvedBy.valid) {
      this.multiClick = true;
      this.spinner.show();
      this.UserService.AddUpdateOrderPbAtAb(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.toastrService.success(res["Msg"]);
            this.router.navigate(["/orderReview/orderreview"]);
          } else if (res["result"] == "Failed") {
            this.toastrService.error(res["Data"][0]["Error"]);
          } else {
            this.toastrService.error(res["Message"]);
          }
          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
          }
          this.multiClick = false;
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required fields");
      this.submitted = true;
      this.multiClick = false;
    }
  }

  onSubmit4() {
    this.submitted = true;
    let Values = [];
    Values.push(
      this.ProjectRequirement.value.Advance,
      this.ProjectRequirement.value.AgainstSupply,
      this.ProjectRequirement.value.AgainstTC,
      this.ProjectRequirement.value.AgainstRetention,
      this.ProjectRequirement.value.AgainstDLP
    );

    if (this.ProjectRequirement.value.RiskInvolved == "true") {
      if (this.ProjectRequirement.value.RiskRemark == "") {
        this.chkRisk = true;
        return;
      } else {
        this.chkRisk = false;
      }
      if (this.ProjectRequirement.value.RiskMitigationPlan == "") {
        this.chkRiskM = true;
        return;
      } else {
        this.chkRiskM = false;
      }
    } else {
      this.ProjectRequirement.value.RiskRemark = "";
      this.ProjectRequirement.value.RiskMitigationPlan = "";
      this.chkRisk = false;
      this.chkRiskM = false;
    }

    if (this.ProjectRequirement.value.Penalties == "true") {
      if (this.ProjectRequirement.value.PenaltiesRemark == "") {
        this.chkPen = true;
        return;
      } else {
        this.chkPen = false;
      }
    } else {
      this.ProjectRequirement.value.PenaltiesRemark = "";
      this.chkPen = false;
    }

    if (this.ProjectRequirement.value.DeviationContract == "true") {
      if (this.ProjectRequirement.value.DeviationContractRemark == "") {
        this.chkDev = true;
        return;
      } else {
        this.chkDev = false;
      }
    } else {
      this.ProjectRequirement.value.DeviationContractRemark = "";
      this.chkDev = false;
    }

    if (this.ProjectRequirement.value.Retention == "true") {
      if (this.ProjectRequirement.value.RetentionRemark == "") {
        this.chkRet = true;
        return;
      } else {
        this.chkRet = false;
      }
    } else {
      this.ProjectRequirement.value.RetentionRemark = "";
      this.chkRet = false;
    }

    let data = {
      OrderInfoId: this.id,
      SpecialRequirement: this.ProjectRequirement.value.SpecialRequirement,
      RiskInvolved: this.ProjectRequirement.value.RiskInvolved,
      RiskRemark: this.ProjectRequirement.value.RiskRemark,
      RiskMitigationPlan: this.ProjectRequirement.value.RiskMitigationPlan,
      Penalties: this.ProjectRequirement.value.Penalties,
      PenaltiesRemark: this.ProjectRequirement.value.PenaltiesRemark,
      DeviationContract: this.ProjectRequirement.value.DeviationContract,
      DeviationContractRemark:
        this.ProjectRequirement.value.DeviationContractRemark,
      Retention: this.ProjectRequirement.value.Retention,
      RetentionRemark: this.ProjectRequirement.value.RetentionRemark,
      PBGGaurantee: this.ProjectRequirement.value.PBGGaurantee,
      ObjOrderGaurantee: Values,
    };
    if (this.ProjectRequirement.valid) {
      this.multiClick = true;
      this.spinner.show();
      this.UserService.AddUpdateOrderProjectRequirement(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.check = 5;
            this.toastrService.success(res["Msg"]);
            let encryptid = this.UserService.encryptData(this.id);
            encryptid = encryptid
              .toString()
              .replace("=", "Ar1t")
              .replace("/", "FGH")
              .replace("+", "THD");
            this.router.navigate(["/orderReview/editproductreview", encryptid]);
          } else if (res["result"] == "Failed") {
            this.toastrService.error(res["Data"][0]["Error"]);
          } else {
            this.toastrService.error(res["Message"]);
          }
          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
          }
          this.multiClick = false;
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required fields");
      this.submitted = true;
      this.multiClick = false;
    }
  }

  enableDisabledFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.enableDisabledFields(control); // Recursively enable disabled fields within nested form groups
      } else {
        if (this.isValidSubmit) {
          control.enable({ emitEvent: false }); // Enable the control without triggering valueChanges event
        } else {
          control.disable({ emitEvent: false }); // Disable the control without triggering valueChanges event
        }
      }
    });
  }

  onSubmit5() {
    this.submitted = true;
    let dataValues = [];
    dataValues.push(
      this.PaymentTermInfo.value.Advance,
      this.PaymentTermInfo.value.AgainstDelivery,
      this.PaymentTermInfo.value.AgainstInstallation,
      this.PaymentTermInfo.value.AgainstTestingandCommissioning,
      this.PaymentTermInfo.value.Againsthandingover,
      this.PaymentTermInfo.value.AfterDLP,
      this.PaymentTermInfo.value.AgainsttoRepairService,
      this.PaymentTermInfo.value.Other1,
      this.PaymentTermInfo.value.Other2
    );
    dataValues.forEach((value: any) => {
      if (value.ModeOfPayment && value.ModeOfPayment.length > 0) {
        value.ModeOfPayment = value.ModeOfPayment[0].id;
      }
    });
    let perCount = 0;
    dataValues.forEach((element) => {
      perCount += Number(element.ReportedValuePer);
    });
    if (perCount > 100) {
      this.toastrService.error(
        "Total Reported Value % can not be more than 100"
      );
      return;
    }
    let dataValues1 = [];
    dataValues1.push(
      this.PaymentTermInfo.value.FromDelivery,
      this.PaymentTermInfo.value.FromStartupCommissioning,
      this.PaymentTermInfo.value.FromHandingOver,
      this.PaymentTermInfo.value.FromInstallation,
      this.PaymentTermInfo.value.EitherDeliveryStartupCommissioning
    );
    if (
      this.PaymentTermInfo.value.ReceivedDate == null ||
      this.PaymentTermInfo.value.ReceivedDate == ""
    ) {
      this.PaymentTermInfo.value.ReceivedDate = null;
    } else {
      this.PaymentTermInfo.value.ReceivedDate = moment(
        this.PaymentTermInfo.value.ReceivedDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.PaymentTermInfo.value.ExpectedDate == null ||
      this.PaymentTermInfo.value.ExpectedDate == ""
    ) {
      this.PaymentTermInfo.value.ExpectedDate = null;
    } else {
      this.PaymentTermInfo.value.ExpectedDate = moment(
        this.PaymentTermInfo.value.ExpectedDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }

    this.PaymentTermInfo.value.ObjOrderSupplier.forEach((element) => {
      element.ExpectedPOAGRReleaseDate = moment(
        element.ExpectedPOAGRReleaseDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    });

    this.PaymentTermInfo.value.ObjOrderSubContractor.forEach((element) => {
      if (element.ExpectedPOAGRReleaseDate != undefined && element.ExpectedPOAGRReleaseDate != null && element.ExpectedPOAGRReleaseDate != "") {
        element.ExpectedPOAGRReleaseDate = moment(element.ExpectedPOAGRReleaseDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      }
    });

    let data = {
      OrderInfoId: this.id,
      ClientRegistration: this.selectedClientId,
      ReceivedDate: this.PaymentTermInfo.value.ReceivedDate,
      ExpectedDate: this.PaymentTermInfo.value.ExpectedDate,
      Warranty: this.PaymentTermInfo.value.Warranty,
      SupplierPO: this.PaymentTermInfo.value.SupplierPO,
      SubContractor: this.PaymentTermInfo.value.SubContractor,
      ObjOrderPaymentTerm: dataValues,
      ObjOrderWarranty: dataValues1,
      ObjOrderSupplier: this.PaymentTermInfo.value.ObjOrderSupplier,
      ObjOrderSubContractor: this.PaymentTermInfo.value.ObjOrderSubContractor,
    };

    if (this.PaymentTermInfo.valid) {
      this.isValidSubmit = true;
      this.enableDisabledFields(this.PaymentTermInfo);
      this.multiClick = true;
      this.spinner.show();
      this.UserService.AddUpdateOrderPaymentTermInfo(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.check = 4;
            this.toastrService.success(res["Msg"]);
            let encryptid = this.UserService.encryptData(this.id);
            encryptid = encryptid
              .toString()
              .replace("=", "Ar1t")
              .replace("/", "FGH")
              .replace("+", "THD");
            this.router.navigate(["/orderReview/editproductreview", encryptid]);
          } else if (res["result"] == "failed") {
            this.toastrService.error(res["Data"][0]["Error"]);
          } else {
            this.toastrService.error(res["Msg"]);
          }
          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
          }
          this.multiClick = false;
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required fields");
      this.submitted = true;
      this.multiClick = false;
    }
  }

  preventDecimalInput(event: Event, field: string): void {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    if (event instanceof KeyboardEvent) {
      const charStr = event.key;
      if (!charStr.match(/^[0-9.]$/)) {
        event.preventDefault();
        return;
      }
      if (charStr === '.' && inputValue.includes('.')) {
        event.preventDefault();
        return;
      }
      if (inputValue.includes('.')) {
        const parts = inputValue.split('.');
        if (parts[1].length >= 2 && input.selectionStart > inputValue.indexOf('.')) {
          event.preventDefault();
        }
      }
      input.addEventListener('input', () => {
        const numericValue = parseFloat(input.value);
        if (numericValue < 0.00 || numericValue > 99999.99) {
          let newValue = numericValue;
          if (numericValue < 0.00) {
            newValue = 0.00;
          } else if (numericValue > 99999.99) {
            newValue = Math.floor(numericValue / 10);
          }

          if (field == 'FreightAmountQAR') {
            this.itemDescription.get('FreightAmountQAR').setValue(newValue.toFixed(2));
            this.toastrService.error("Freight Amount (QAR) should be between 0.00 to 99999.99");
          }
          else if (field == 'ReportedCurrencyRate') {
            this.itemDescription.get('ReportedCurrencyRate').setValue(newValue.toFixed(2));
            this.toastrService.error("Reported Currency Rate should be between 0.00 to 99999.99");
          }
        }
      });
    }
  }

  itemsFormValidate(event: Event, i: number, fieldName: string): void {
    const input = event.target as HTMLInputElement;

    const item = (this.itemDescription.get('ObjOrderItemDescription') as FormArray).at(i) as FormGroup;
    const control = item.get(fieldName) as FormControl;

    const inputValue = input.value;
    if (event instanceof KeyboardEvent) {
      const charStr = event.key;
      if (!charStr.match(/^[0-9.]$/)) {
        event.preventDefault();
        return;
      }
      if (charStr === '.' && inputValue.includes('.')) {
        event.preventDefault();
        return;
      }
      if (inputValue.includes('.')) {
        const parts = inputValue.split('.');
        if (parts[1].length >= 2 && input.selectionStart > inputValue.indexOf('.')) {
          event.preventDefault();
        }
      }
      if (fieldName === 'DiscountPer' || fieldName === 'VatRate') {
        input.addEventListener('input', () => {
          const numericValue = parseFloat(input.value);
          if (numericValue < 0 || numericValue > 100.00) {
            let newValue = numericValue;
            if (numericValue < 0) {
              newValue = 0;
            } else if (numericValue > 100.00) {
              newValue = Math.floor(numericValue / 10);
            }
            control.setValue(newValue);
            this.toastrService.error("Percentage value should be between 0.00% to 100.00%");
          }
        });
      }
      else if (fieldName === 'UnitRate' || fieldName === 'TotalDiscountValue') {
        input.addEventListener('input', () => {
          const numericValue = parseFloat(input.value);
          if (numericValue < 0.00 || numericValue > 999999.99) {
            let newValue = numericValue;
            if (numericValue < 0.00) {
              newValue = 0.00;
            } else if (numericValue > 999999.99) {
              newValue = Math.floor(numericValue / 10);
            }
            control.setValue(newValue.toFixed(2));
            this.toastrService.error("Value should be between 0.00 to 999999.99");
          }
        });
      }
    }
  }

  percentValidate(event: Event, i: number, fieldName: string): void {
    const input = event.target as HTMLInputElement;

    const item = (this.commercialForm.get('ObjOrderCredit') as FormArray).at(i) as FormGroup;
    const control = item.get(fieldName) as FormControl;

    const inputValue = input.value;
    if (event instanceof KeyboardEvent) {
      const charStr = event.key;
      if (!charStr.match(/^[0-9.]$/)) {
        event.preventDefault();
        return;
      }
      if (charStr === '.' && inputValue.includes('.')) {
        event.preventDefault();
        return;
      }
      if (inputValue.includes('.')) {
        const parts = inputValue.split('.');
        if (parts[1].length >= 2 && input.selectionStart > inputValue.indexOf('.')) {
          event.preventDefault();
        }
      }
      if (fieldName === 'CreditSplitPercentage') {
        input.addEventListener('input', () => {
          const numericValue = parseFloat(input.value);
          if (numericValue < 0 || numericValue > 100.00) {
            let newValue = numericValue;
            if (numericValue < 0) {
              newValue = 0;
            } else if (numericValue > 100.00) {
              newValue = Math.floor(numericValue / 10);
            }
            control.setValue(newValue);
            this.toastrService.error("Credit Split Percentage should be between 0.00% to 100.00%");
          }
        });
      }
    }
  }

}
